import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { ExcelMaterialImport_ShellService } from './ExcelMaterialImport.shell.service';
import { ExcelMaterialImport_OperationService } from './ExcelMaterialImport.operation.service';
import { ExcelMaterialImport_DatasourceService } from './ExcelMaterialImport.datasource.index';
import { ExcelMaterialImport_FlowService } from './ExcelMaterialImport.flow.index';
import { ExcelMaterialImport_ReportService } from './ExcelMaterialImport.report.index';
import { ExcelMaterialImport_LocalizationService } from './ExcelMaterialImport.localization.service';
import { ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService } from './ExcelMaterialImport.excel_material_import_staging_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './ExcelMaterialImport.frontend.types'
import { $frontendTypes as $types} from './ExcelMaterialImport.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { ExcelMaterialImport_import_statuses_dd_singleComponent } from './ExcelMaterialImport.import_statuses_dd_single.component'


interface IExcelMaterialImport_excel_material_import_staging_gridComponentEntity {
  Id?: string, ImportStatus?: string, ImportCreatedDate?: string, ImportCompletedDate?: string, ImportErrorMessage?: string, ImportRequestId?: string, LookupCode?: string, OwnerLookupCode?: string, ProjectLookupCode?: string, GlobalMaterialName?: string, MaterialName?: string, MaterialDescription?: string, MaterialGroup?: string, MaterialStatus?: string, ReceiveStatus?: string, NmfcNumber?: string, NmfcSubNumber?: string, LotControlled_YN?: string, SerialControlled_YN?: string, FixedWeight_YN?: string, FixedDimension_YN?: string, FixedVolume_YN?: string, AllowReceiving_YN?: string, AllowShipping_YN?: string, AllowReturns_YN?: string, AllowBlindReceiving_YN?: string, SkipLpFifoAllocation_YN?: string, IncludeInCycleCount_YN?: string, KitType?: string, CurrencyId?: string, ShelfLifeDays?: string, MinimumDays?: string, StandardPrice?: string, StandardCost?: string, AllocationStrategy?: string, PackageAllocationStrategy?: string, DaysToFirstTasteTest?: string, TasteTestCycleDays?: string, ReallocationExpirationWindow?: string, PrimaryPickLocationsPerWarehouse?: string, ReceivingOverageThreshold?: string, StandardUnitsPerHour?: string, AmbientTimeInHours?: string, CycleCountTolerance?: string, StorageCategoryRule?: string, Uom?: string, SubUom?: string, SubUomQuantity?: string, DynamicUom?: string, UomUpc?: string, UomAllowSale_YN?: string, UomAllowPurchase_YN?: string, UomReporting_YN?: string, UomNonDefault_YN?: string, UomPalletTie?: string, UomPalletHigh?: string, UomStandardPrice?: string, UomStandardCost?: string, UomWeight?: string, UomShippingWeight?: string, UomLength?: string, UomWidth?: string, UomHeight?: string, UomVolume?: string, UomShippingVolume?: string, UomWeightUnit?: string, UomDimensionUnit?: string, UomVolumeUnit?: string, ManufacturingCrewComplement?: string, LpMixingRestriction?: string, AutoPopulateLot?: string, AutoPopulateVendorLot?: string, MaterialTagList?: string, UDF01Name?: string, UDF01Value?: string, UDF02Name?: string, UDF02Value?: string, UDF03Name?: string, UDF03Value?: string, UDF04Name?: string, UDF04Value?: string, UDF05Name?: string, UDF05Value?: string, UDF06Name?: string, UDF06Value?: string, UDF07Name?: string, UDF07Value?: string, UDF08Name?: string, UDF08Value?: string, UDF09Name?: string, UDF09Value?: string, UDF10Name?: string, UDF10Value?: string, UDF11Name?: string, UDF11Value?: string, UDF12Name?: string, UDF12Value?: string, UDF13Name?: string, UDF13Value?: string, UDF14Name?: string, UDF14Value?: string, UDF15Name?: string, UDF15Value?: string, UDF16Name?: string, UDF16Value?: string, UDF17Name?: string, UDF17Value?: string, UDF18Name?: string, UDF18Value?: string, UDF19Name?: string, UDF19Value?: string, UDF20Name?: string, UDF20Value?: string}



class ExcelMaterialImport_excel_material_import_staging_gridComponentRowModel extends GridRowModel {
  grid: ExcelMaterialImport_excel_material_import_staging_gridComponent;
  entity: IExcelMaterialImport_excel_material_import_staging_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    json_test_display: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    xml_test_display: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  override cells = {
    Id: null,
    ImportStatus: null,
    ImportCreatedDate: null,
    ImportCompletedDate: null,
    ImportErrorMessage: null,
    ImportRequestId: null,
    LookupCode: null,
    OwnerLookupCode: null,
    ProjectLookupCode: null,
    GlobalMaterialName: null,
    MaterialName: null,
    MaterialDescription: null,
    MaterialGroup: null,
    MaterialStatus: null,
    ReceiveStatus: null,
    NmfcNumber: null,
    NmfcSubNumber: null,
    LotControlled_YN: null,
    SerialControlled_YN: null,
    FixedWeight_YN: null,
    FixedDimension_YN: null,
    FixedVolume_YN: null,
    AllowReceiving_YN: null,
    AllowShipping_YN: null,
    AllowReturns_YN: null,
    AllowBlindReceiving_YN: null,
    SkipLpFifoAllocation_YN: null,
    IncludeInCycleCount_YN: null,
    KitType: null,
    CurrencyId: null,
    ShelfLifeDays: null,
    MinimumDays: null,
    StandardPrice: null,
    StandardCost: null,
    AllocationStrategy: null,
    PackageAllocationStrategy: null,
    DaysToFirstTasteTest: null,
    TasteTestCycleDays: null,
    ReallocationExpirationWindow: null,
    PrimaryPickLocationsPerWarehouse: null,
    ReceivingOverageThreshold: null,
    StandardUnitsPerHour: null,
    AmbientTimeInHours: null,
    CycleCountTolerance: null,
    StorageCategoryRule: null,
    Uom: null,
    SubUom: null,
    SubUomQuantity: null,
    DynamicUom: null,
    UomUpc: null,
    UomAllowSale_YN: null,
    UomAllowPurchase_YN: null,
    UomReporting_YN: null,
    UomNonDefault_YN: null,
    UomPalletTie: null,
    UomPalletHigh: null,
    UomStandardPrice: null,
    UomStandardCost: null,
    UomWeight: null,
    UomShippingWeight: null,
    UomLength: null,
    UomWidth: null,
    UomHeight: null,
    UomVolume: null,
    UomWeightUnit: null,
    UomDimensionUnit: null,
    UomVolumeUnit: null,
    ManufacturingCrewComplement: null,
    LpMixingRestriction: null,
    AutoPopulateLot: null,
    AutoPopulateVendorLot: null,
    MaterialTagList: null,
    UDF01Name: null,
    UDF01Value: null,
    UDF02Name: null,
    UDF02Value: null,
    UDF03Name: null,
    UDF03Value: null,
    UDF04Name: null,
    UDF04Value: null,
    UDF05Name: null,
    UDF05Value: null,
    UDF06Name: null,
    UDF06Value: null,
    UDF07Name: null,
    UDF07Value: null,
    UDF08Name: null,
    UDF08Value: null,
    UDF09Name: null,
    UDF09Value: null,
    UDF10Name: null,
    UDF10Value: null,
    UDF11Name: null,
    UDF11Value: null,
    UDF12Name: null,
    UDF12Value: null,
    UDF13Name: null,
    UDF13Value: null,
    UDF14Name: null,
    UDF14Value: null,
    UDF15Name: null,
    UDF15Value: null,
    UDF16Name: null,
    UDF16Value: null,
    UDF17Name: null,
    UDF17Value: null,
    UDF18Name: null,
    UDF18Value: null,
    UDF19Name: null,
    UDF19Value: null,
    UDF20Name: null,
    UDF20Value: null,
    json_test: null,
    xml_test: null,
  }



  constructor(
    grid: ExcelMaterialImport_excel_material_import_staging_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: ExcelMaterialImport_ShellService,
private $datasources: ExcelMaterialImport_DatasourceService,
private $flows: ExcelMaterialImport_FlowService,
private $reports: ExcelMaterialImport_ReportService,
private $localization: ExcelMaterialImport_LocalizationService,
private $operations: ExcelMaterialImport_OperationService,
private $logger: CleanupLoggerService,
private $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ImportStatus = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ImportStatus,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ImportCreatedDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ImportCreatedDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ImportCompletedDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ImportCompletedDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ImportErrorMessage = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.ImportErrorMessage,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ImportRequestId = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ImportRequestId,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LookupCode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.LookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.OwnerLookupCode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.OwnerLookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ProjectLookupCode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ProjectLookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.GlobalMaterialName = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.GlobalMaterialName,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.MaterialName = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.MaterialName,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.MaterialDescription = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.MaterialDescription,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.MaterialGroup = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.MaterialGroup,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.MaterialStatus = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.MaterialStatus,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ReceiveStatus = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ReceiveStatus,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.NmfcNumber = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.NmfcNumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.NmfcSubNumber = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.NmfcSubNumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LotControlled_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.LotControlled_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.SerialControlled_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.SerialControlled_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.FixedWeight_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.FixedWeight_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.FixedDimension_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.FixedDimension_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.FixedVolume_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.FixedVolume_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.AllowReceiving_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.AllowReceiving_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.AllowShipping_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.AllowShipping_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.AllowReturns_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.AllowReturns_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.AllowBlindReceiving_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.AllowBlindReceiving_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.SkipLpFifoAllocation_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.SkipLpFifoAllocation_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.IncludeInCycleCount_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.IncludeInCycleCount_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.KitType = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.KitType,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CurrencyId = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CurrencyId,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ShelfLifeDays = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ShelfLifeDays,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.MinimumDays = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.MinimumDays,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.StandardPrice = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.StandardPrice,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.StandardCost = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.StandardCost,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.AllocationStrategy = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.AllocationStrategy,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.PackageAllocationStrategy = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.PackageAllocationStrategy,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.DaysToFirstTasteTest = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.DaysToFirstTasteTest,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.TasteTestCycleDays = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.TasteTestCycleDays,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ReallocationExpirationWindow = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ReallocationExpirationWindow,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.PrimaryPickLocationsPerWarehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.PrimaryPickLocationsPerWarehouse,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ReceivingOverageThreshold = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ReceivingOverageThreshold,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.StandardUnitsPerHour = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.StandardUnitsPerHour,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.AmbientTimeInHours = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.AmbientTimeInHours,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CycleCountTolerance = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CycleCountTolerance,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.StorageCategoryRule = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.StorageCategoryRule,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Uom,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.SubUom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.SubUom,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.SubUomQuantity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.SubUomQuantity,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.DynamicUom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.DynamicUom,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomUpc = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomUpc,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomAllowSale_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomAllowSale_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomAllowPurchase_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomAllowPurchase_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomReporting_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomReporting_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomNonDefault_YN = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomNonDefault_YN,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomPalletTie = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomPalletTie,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomPalletHigh = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomPalletHigh,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomStandardPrice = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomStandardPrice,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomStandardCost = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomStandardCost,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomWeight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomWeight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomShippingWeight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomShippingWeight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomLength = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomLength,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomWidth = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomWidth,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomHeight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomHeight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomVolume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomVolume,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomWeightUnit = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomWeightUnit,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomDimensionUnit = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomDimensionUnit,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UomVolumeUnit = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UomVolumeUnit,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ManufacturingCrewComplement = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ManufacturingCrewComplement,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LpMixingRestriction = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.LpMixingRestriction,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.AutoPopulateLot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.AutoPopulateLot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.AutoPopulateVendorLot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.AutoPopulateVendorLot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.MaterialTagList = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.MaterialTagList,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF01Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF01Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF01Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF01Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF02Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF02Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF02Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF02Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF03Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF03Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF03Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF03Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF04Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF04Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF04Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF04Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF05Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF05Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF05Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF05Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF06Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF06Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF06Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF06Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF07Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF07Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF07Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF07Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF08Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF08Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF08Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF08Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF09Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF09Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF09Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF09Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF10Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF10Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF10Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF10Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF11Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF11Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF11Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF11Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF12Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF12Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF12Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF12Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF13Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF13Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF13Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF13Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF14Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF14Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF14Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF14Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF15Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF15Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF15Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF15Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF16Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF16Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF16Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF16Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF17Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF17Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF17Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF17Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF18Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF18Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF18Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF18Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF19Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF19Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF19Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF19Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF20Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF20Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.UDF20Value = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.UDF20Value,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.json_test = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.json_test,
       new CodeBoxModel(this.formGroup.controls['json_test_display'] as DatexFormControl, null, null, false, 'json', null)
,
null
      );
    
    this.cells.xml_test = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.xml_test,
       new CodeBoxModel(this.formGroup.controls['xml_test_display'] as DatexFormControl, null, null, false, 'xml', null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IExcelMaterialImport_excel_material_import_staging_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IExcelMaterialImport_excel_material_import_staging_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      import_status:  $grid.filters.import_status.control.value ,
      full_text_search:  $grid.fullTextSearch ,
    };
    const data = await this.$datasources.ExcelMaterialImport.ds_material_import_staging_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IExcelMaterialImport_excel_material_import_staging_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.Id;
    (this.cells.ImportStatus.displayControl as TextModel).text = $row.entity.ImportStatus;
    (this.cells.ImportCreatedDate.displayControl as TextModel).text = $row.entity.ImportCreatedDate;
    (this.cells.ImportCompletedDate.displayControl as TextModel).text = $row.entity.ImportCompletedDate;
    (this.cells.ImportErrorMessage.displayControl as TextModel).text = $row.entity.ImportErrorMessage;
    (this.cells.ImportRequestId.displayControl as TextModel).text = $row.entity.ImportRequestId;
    (this.cells.LookupCode.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.OwnerLookupCode.displayControl as TextModel).text = $row.entity.OwnerLookupCode;
    (this.cells.ProjectLookupCode.displayControl as TextModel).text = $row.entity.ProjectLookupCode;
    (this.cells.GlobalMaterialName.displayControl as TextModel).text = $row.entity.GlobalMaterialName;
    (this.cells.MaterialName.displayControl as TextModel).text = $row.entity.MaterialName;
    (this.cells.MaterialDescription.displayControl as TextModel).text = $row.entity.MaterialDescription;
    (this.cells.MaterialGroup.displayControl as TextModel).text = $row.entity.MaterialGroup;
    (this.cells.MaterialStatus.displayControl as TextModel).text = $row.entity.MaterialStatus;
    (this.cells.ReceiveStatus.displayControl as TextModel).text = $row.entity.ReceiveStatus;
    (this.cells.NmfcNumber.displayControl as TextModel).text = $row.entity.NmfcNumber;
    (this.cells.NmfcSubNumber.displayControl as TextModel).text = $row.entity.NmfcSubNumber;
    (this.cells.LotControlled_YN.displayControl as TextModel).text = $row.entity.LotControlled_YN;
    (this.cells.SerialControlled_YN.displayControl as TextModel).text = $row.entity.SerialControlled_YN;
    (this.cells.FixedWeight_YN.displayControl as TextModel).text = $row.entity.FixedWeight_YN;
    (this.cells.FixedDimension_YN.displayControl as TextModel).text = $row.entity.FixedDimension_YN;
    (this.cells.FixedVolume_YN.displayControl as TextModel).text = $row.entity.FixedVolume_YN;
    (this.cells.AllowReceiving_YN.displayControl as TextModel).text = $row.entity.AllowReceiving_YN;
    (this.cells.AllowShipping_YN.displayControl as TextModel).text = $row.entity.AllowShipping_YN;
    (this.cells.AllowReturns_YN.displayControl as TextModel).text = $row.entity.AllowReturns_YN;
    (this.cells.AllowBlindReceiving_YN.displayControl as TextModel).text = $row.entity.AllowBlindReceiving_YN;
    (this.cells.SkipLpFifoAllocation_YN.displayControl as TextModel).text = $row.entity.SkipLpFifoAllocation_YN;
    (this.cells.IncludeInCycleCount_YN.displayControl as TextModel).text = $row.entity.IncludeInCycleCount_YN;
    (this.cells.KitType.displayControl as TextModel).text = $row.entity.KitType;
    (this.cells.CurrencyId.displayControl as TextModel).text = $row.entity.CurrencyId;
    (this.cells.ShelfLifeDays.displayControl as TextModel).text = $row.entity.ShelfLifeDays;
    (this.cells.MinimumDays.displayControl as TextModel).text = $row.entity.MinimumDays;
    (this.cells.StandardPrice.displayControl as TextModel).text = $row.entity.StandardPrice;
    (this.cells.StandardCost.displayControl as TextModel).text = $row.entity.StandardCost;
    (this.cells.AllocationStrategy.displayControl as TextModel).text = $row.entity.AllocationStrategy;
    (this.cells.PackageAllocationStrategy.displayControl as TextModel).text = $row.entity.PackageAllocationStrategy;
    (this.cells.DaysToFirstTasteTest.displayControl as TextModel).text = $row.entity.DaysToFirstTasteTest;
    (this.cells.TasteTestCycleDays.displayControl as TextModel).text = $row.entity.TasteTestCycleDays;
    (this.cells.ReallocationExpirationWindow.displayControl as TextModel).text = $row.entity.ReallocationExpirationWindow;
    (this.cells.PrimaryPickLocationsPerWarehouse.displayControl as TextModel).text = $row.entity.PrimaryPickLocationsPerWarehouse;
    (this.cells.ReceivingOverageThreshold.displayControl as TextModel).text = $row.entity.ReceivingOverageThreshold;
    (this.cells.StandardUnitsPerHour.displayControl as TextModel).text = $row.entity.StandardUnitsPerHour;
    (this.cells.AmbientTimeInHours.displayControl as TextModel).text = $row.entity.AmbientTimeInHours;
    (this.cells.CycleCountTolerance.displayControl as TextModel).text = $row.entity.CycleCountTolerance;
    (this.cells.StorageCategoryRule.displayControl as TextModel).text = $row.entity.StorageCategoryRule;
    (this.cells.Uom.displayControl as TextModel).text = $row.entity.Uom;
    (this.cells.SubUom.displayControl as TextModel).text = $row.entity.SubUom;
    (this.cells.SubUomQuantity.displayControl as TextModel).text = $row.entity.SubUomQuantity;
    (this.cells.DynamicUom.displayControl as TextModel).text = $row.entity.DynamicUom;
    (this.cells.UomUpc.displayControl as TextModel).text = $row.entity.UomUpc;
    (this.cells.UomAllowSale_YN.displayControl as TextModel).text = $row.entity.UomAllowSale_YN;
    (this.cells.UomAllowPurchase_YN.displayControl as TextModel).text = $row.entity.UomAllowPurchase_YN;
    (this.cells.UomReporting_YN.displayControl as TextModel).text = $row.entity.UomReporting_YN;
    (this.cells.UomNonDefault_YN.displayControl as TextModel).text = $row.entity.UomNonDefault_YN;
    (this.cells.UomPalletTie.displayControl as TextModel).text = $row.entity.UomPalletTie;
    (this.cells.UomPalletHigh.displayControl as TextModel).text = $row.entity.UomPalletHigh;
    (this.cells.UomStandardPrice.displayControl as TextModel).text = $row.entity.UomStandardPrice;
    (this.cells.UomStandardCost.displayControl as TextModel).text = $row.entity.UomStandardCost;
    (this.cells.UomWeight.displayControl as TextModel).text = $row.entity.UomWeight;
    (this.cells.UomShippingWeight.displayControl as TextModel).text = $row.entity.UomShippingWeight;
    (this.cells.UomLength.displayControl as TextModel).text = $row.entity.UomLength;
    (this.cells.UomWidth.displayControl as TextModel).text = $row.entity.UomWidth;
    (this.cells.UomHeight.displayControl as TextModel).text = $row.entity.UomHeight;
    (this.cells.UomVolume.displayControl as TextModel).text = $row.entity.UomVolume;
    (this.cells.UomWeightUnit.displayControl as TextModel).text = $row.entity.UomWeightUnit;
    (this.cells.UomDimensionUnit.displayControl as TextModel).text = $row.entity.UomDimensionUnit;
    (this.cells.UomVolumeUnit.displayControl as TextModel).text = $row.entity.UomVolumeUnit;
    (this.cells.ManufacturingCrewComplement.displayControl as TextModel).text = $row.entity.ManufacturingCrewComplement;
    (this.cells.LpMixingRestriction.displayControl as TextModel).text = $row.entity.LpMixingRestriction;
    (this.cells.AutoPopulateLot.displayControl as TextModel).text = $row.entity.AutoPopulateLot;
    (this.cells.AutoPopulateVendorLot.displayControl as TextModel).text = $row.entity.AutoPopulateVendorLot;
    (this.cells.MaterialTagList.displayControl as TextModel).text = $row.entity.MaterialTagList;
    (this.cells.UDF01Name.displayControl as TextModel).text = $row.entity.UDF01Name;
    (this.cells.UDF01Value.displayControl as TextModel).text = $row.entity.UDF01Value;
    (this.cells.UDF02Name.displayControl as TextModel).text = $row.entity.UDF02Name;
    (this.cells.UDF02Value.displayControl as TextModel).text = $row.entity.UDF02Value;
    (this.cells.UDF03Name.displayControl as TextModel).text = $row.entity.UDF03Name;
    (this.cells.UDF03Value.displayControl as TextModel).text = $row.entity.UDF03Value;
    (this.cells.UDF04Name.displayControl as TextModel).text = $row.entity.UDF04Name;
    (this.cells.UDF04Value.displayControl as TextModel).text = $row.entity.UDF04Value;
    (this.cells.UDF05Name.displayControl as TextModel).text = $row.entity.UDF05Name;
    (this.cells.UDF05Value.displayControl as TextModel).text = $row.entity.UDF05Value;
    (this.cells.UDF06Name.displayControl as TextModel).text = $row.entity.UDF06Name;
    (this.cells.UDF06Value.displayControl as TextModel).text = $row.entity.UDF06Value;
    (this.cells.UDF07Name.displayControl as TextModel).text = $row.entity.UDF07Name;
    (this.cells.UDF07Value.displayControl as TextModel).text = $row.entity.UDF07Value;
    (this.cells.UDF08Name.displayControl as TextModel).text = $row.entity.UDF08Name;
    (this.cells.UDF08Value.displayControl as TextModel).text = $row.entity.UDF08Value;
    (this.cells.UDF09Name.displayControl as TextModel).text = $row.entity.UDF09Name;
    (this.cells.UDF09Value.displayControl as TextModel).text = $row.entity.UDF09Value;
    (this.cells.UDF10Name.displayControl as TextModel).text = $row.entity.UDF10Name;
    (this.cells.UDF10Value.displayControl as TextModel).text = $row.entity.UDF10Value;
    (this.cells.UDF11Name.displayControl as TextModel).text = $row.entity.UDF11Name;
    (this.cells.UDF11Value.displayControl as TextModel).text = $row.entity.UDF11Value;
    (this.cells.UDF12Name.displayControl as TextModel).text = $row.entity.UDF12Name;
    (this.cells.UDF12Value.displayControl as TextModel).text = $row.entity.UDF12Value;
    (this.cells.UDF13Name.displayControl as TextModel).text = $row.entity.UDF13Name;
    (this.cells.UDF13Value.displayControl as TextModel).text = $row.entity.UDF13Value;
    (this.cells.UDF14Name.displayControl as TextModel).text = $row.entity.UDF14Name;
    (this.cells.UDF14Value.displayControl as TextModel).text = $row.entity.UDF14Value;
    (this.cells.UDF15Name.displayControl as TextModel).text = $row.entity.UDF15Name;
    (this.cells.UDF15Value.displayControl as TextModel).text = $row.entity.UDF15Value;
    (this.cells.UDF16Name.displayControl as TextModel).text = $row.entity.UDF16Name;
    (this.cells.UDF16Value.displayControl as TextModel).text = $row.entity.UDF16Value;
    (this.cells.UDF17Name.displayControl as TextModel).text = $row.entity.UDF17Name;
    (this.cells.UDF17Value.displayControl as TextModel).text = $row.entity.UDF17Value;
    (this.cells.UDF18Name.displayControl as TextModel).text = $row.entity.UDF18Name;
    (this.cells.UDF18Value.displayControl as TextModel).text = $row.entity.UDF18Value;
    (this.cells.UDF19Name.displayControl as TextModel).text = $row.entity.UDF19Name;
    (this.cells.UDF19Value.displayControl as TextModel).text = $row.entity.UDF19Value;
    (this.cells.UDF20Name.displayControl as TextModel).text = $row.entity.UDF20Name;
    (this.cells.UDF20Value.displayControl as TextModel).text = $row.entity.UDF20Value;

    await this.on_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      this.isNew = false;
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'ImportErrorMessage' : {
        this.on_error_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_error_clicked(event = null) {
    return this.on_error_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_error_clickedInternal(
    $row: ExcelMaterialImport_excel_material_import_staging_gridComponentRowModel,
  $grid: ExcelMaterialImport_excel_material_import_staging_gridComponent, 
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/14/2024
  
  let is_json: boolean = false;
  let is_xml: boolean = false;
  
  let payload_string: string = $row.entity.ImportErrorMessage;
  payload_string = payload_string.trim();
  
  try {
      $row.cells.json_test.displayControl.value = payload_string;
      if ($utils.isDefined($row.cells.json_test.displayControl.value)) {
          is_json = true;
      }
  } catch (e) { }
  
  try {
      if (payload_string.includes("<") && payload_string.includes(">")) {
          $row.cells.xml_test.displayControl.value = payload_string;
          if ($utils.isDefined($row.cells.xml_test.displayControl.value)) {
              is_xml = true;
          }
      }
  } catch (e) { }
  
  if (is_json) {
      await $shell.ExcelMaterialImport.openview_json_payloadDialog({
          payload: payload_string,
          title: "ImportErrorMessage"
      }, "modal", EModalSize.Xlarge);
  } else if (is_xml) {
      await $shell.ExcelMaterialImport.openview_xml_payloadDialog({
          payload: payload_string,
          title: "ImportErrorMessage"
      }, "modal", EModalSize.Xlarge);
  } else {
      $shell.ExcelMaterialImport.openInfoDialog("ImportErrorMessage", payload_string);
  }
  }
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $row: ExcelMaterialImport_excel_material_import_staging_gridComponentRowModel,
  $grid: ExcelMaterialImport_excel_material_import_staging_gridComponent, 
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/14/2024
  
  const format = `MM/DD/YYYY, LT`;
  
  if ($utils.isDefined(format)) {
      if ($utils.isDefined($row.entity.ImportCreatedDate)) {
          $row.cells.ImportCreatedDate.displayControl.text = $utils.date.format($row.entity.ImportCreatedDate, format);
      };
      if ($utils.isDefined($row.entity.ImportCompletedDate)) {
          $row.cells.ImportCompletedDate.displayControl.text = $utils.date.format($row.entity.ImportCompletedDate, format);
      };
  };
  
  let payload = $row.entity.ImportErrorMessage;
  
  if ($utils.isDefined(payload)) {
      payload = (payload.length > 50) ? `${payload.substring(0, 50)}...` : payload;
      $row.cells.ImportErrorMessage.displayControl.text = payload;
  }
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => ExcelMaterialImport_import_statuses_dd_singleComponent),
  ],
  selector: 'ExcelMaterialImport-excel_material_import_staging_grid',
  templateUrl: './ExcelMaterialImport.excel_material_import_staging_grid.component.html'
})
export class ExcelMaterialImport_excel_material_import_staging_gridComponent extends BaseComponent implements OnInit, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IExcelMaterialImport_excel_material_import_staging_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;



  //#region Variables
  vars: { running?: boolean } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'ID', false, false, null, false),       ImportStatus: new GridHeaderModel(new HeaderStyles(null, null), 'ImportStatus', 'Status', false, false, null, false),       ImportCreatedDate: new GridHeaderModel(new HeaderStyles(null, null), 'ImportCreatedDate', 'Created', false, false, null, false),       ImportCompletedDate: new GridHeaderModel(new HeaderStyles(null, null), 'ImportCompletedDate', 'Completed', false, false, null, false),       ImportErrorMessage: new GridHeaderModel(new HeaderStyles(null, null), 'ImportErrorMessage', 'Message', false, false, null, false),       ImportRequestId: new GridHeaderModel(new HeaderStyles(null, null), 'ImportRequestId', 'Request ID', false, false, null, false),       LookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'LookupCode', 'Material code', false, false, null, false),       OwnerLookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'OwnerLookupCode', 'Owner code', false, false, null, false),       ProjectLookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'ProjectLookupCode', 'Project code', false, false, null, false),       GlobalMaterialName: new GridHeaderModel(new HeaderStyles(null, null), 'GlobalMaterialName', 'Global material name', false, false, null, false),       MaterialName: new GridHeaderModel(new HeaderStyles(null, null), 'MaterialName', 'Material name', false, false, null, false),       MaterialDescription: new GridHeaderModel(new HeaderStyles(null, null), 'MaterialDescription', 'Material description', false, false, null, false),       MaterialGroup: new GridHeaderModel(new HeaderStyles(null, null), 'MaterialGroup', 'Material group', false, false, null, false),       MaterialStatus: new GridHeaderModel(new HeaderStyles(null, null), 'MaterialStatus', 'Material status', false, false, null, false),       ReceiveStatus: new GridHeaderModel(new HeaderStyles(null, null), 'ReceiveStatus', 'Receive status', false, false, null, false),       NmfcNumber: new GridHeaderModel(new HeaderStyles(null, null), 'NmfcNumber', 'Nmfc number', false, false, null, false),       NmfcSubNumber: new GridHeaderModel(new HeaderStyles(null, null), 'NmfcSubNumber', 'Nmfc sub number', false, false, null, false),       LotControlled_YN: new GridHeaderModel(new HeaderStyles(null, null), 'LotControlled_YN', 'Lot controlled_yn', false, false, null, false),       SerialControlled_YN: new GridHeaderModel(new HeaderStyles(null, null), 'SerialControlled_YN', 'Serial controlled_yn', false, false, null, false),       FixedWeight_YN: new GridHeaderModel(new HeaderStyles(null, null), 'FixedWeight_YN', 'Fixed weight_yn', false, false, null, false),       FixedDimension_YN: new GridHeaderModel(new HeaderStyles(null, null), 'FixedDimension_YN', 'Fixed dimension_yn', false, false, null, false),       FixedVolume_YN: new GridHeaderModel(new HeaderStyles(null, null), 'FixedVolume_YN', 'Fixed volume_yn', false, false, null, false),       AllowReceiving_YN: new GridHeaderModel(new HeaderStyles(null, null), 'AllowReceiving_YN', 'Allow receiving_yn', false, false, null, false),       AllowShipping_YN: new GridHeaderModel(new HeaderStyles(null, null), 'AllowShipping_YN', 'Allow shipping_yn', false, false, null, false),       AllowReturns_YN: new GridHeaderModel(new HeaderStyles(null, null), 'AllowReturns_YN', 'Allow returns_yn', false, false, null, false),       AllowBlindReceiving_YN: new GridHeaderModel(new HeaderStyles(null, null), 'AllowBlindReceiving_YN', 'Allow blind receiving_yn', false, false, null, false),       SkipLpFifoAllocation_YN: new GridHeaderModel(new HeaderStyles(null, null), 'SkipLpFifoAllocation_YN', 'Skip LP FIFO allocation_yn', false, false, null, false),       IncludeInCycleCount_YN: new GridHeaderModel(new HeaderStyles(null, null), 'IncludeInCycleCount_YN', 'Include In cycle count_yn', false, false, null, false),       KitType: new GridHeaderModel(new HeaderStyles(null, null), 'KitType', 'Kit type', false, false, null, false),       CurrencyId: new GridHeaderModel(new HeaderStyles(null, null), 'CurrencyId', 'Currency ID', false, false, null, false),       ShelfLifeDays: new GridHeaderModel(new HeaderStyles(null, null), 'ShelfLifeDays', 'Shelf life days', false, false, null, false),       MinimumDays: new GridHeaderModel(new HeaderStyles(null, null), 'MinimumDays', 'Minimum days', false, false, null, false),       StandardPrice: new GridHeaderModel(new HeaderStyles(null, null), 'StandardPrice', 'Standard price', false, false, null, false),       StandardCost: new GridHeaderModel(new HeaderStyles(null, null), 'StandardCost', 'Standard cost', false, false, null, false),       AllocationStrategy: new GridHeaderModel(new HeaderStyles(null, null), 'AllocationStrategy', 'Allocation strategy', false, false, null, false),       PackageAllocationStrategy: new GridHeaderModel(new HeaderStyles(null, null), 'PackageAllocationStrategy', 'Package allocation strategy', false, false, null, false),       DaysToFirstTasteTest: new GridHeaderModel(new HeaderStyles(null, null), 'DaysToFirstTasteTest', 'Days to first taste test', false, false, null, false),       TasteTestCycleDays: new GridHeaderModel(new HeaderStyles(null, null), 'TasteTestCycleDays', 'Taste test cycle days', false, false, null, false),       ReallocationExpirationWindow: new GridHeaderModel(new HeaderStyles(null, null), 'ReallocationExpirationWindow', 'Reallocation expiration window', false, false, null, false),       PrimaryPickLocationsPerWarehouse: new GridHeaderModel(new HeaderStyles(null, null), 'PrimaryPickLocationsPerWarehouse', 'Primary pick locations per warehouse', false, false, null, false),       ReceivingOverageThreshold: new GridHeaderModel(new HeaderStyles(null, null), 'ReceivingOverageThreshold', 'Receiving overage threshold', false, false, null, false),       StandardUnitsPerHour: new GridHeaderModel(new HeaderStyles(null, null), 'StandardUnitsPerHour', 'Standard units per hour', false, false, null, false),       AmbientTimeInHours: new GridHeaderModel(new HeaderStyles(null, null), 'AmbientTimeInHours', 'Ambient time in hours', false, false, null, false),       CycleCountTolerance: new GridHeaderModel(new HeaderStyles(null, null), 'CycleCountTolerance', 'Cycle count tolerance', false, false, null, false),       StorageCategoryRule: new GridHeaderModel(new HeaderStyles(null, null), 'StorageCategoryRule', 'Storage category rule', false, false, null, false),       Uom: new GridHeaderModel(new HeaderStyles(null, null), 'Uom', 'UOM', false, false, null, false),       SubUom: new GridHeaderModel(new HeaderStyles(null, null), 'SubUom', 'Sub UOM', false, false, null, false),       SubUomQuantity: new GridHeaderModel(new HeaderStyles(null, null), 'SubUomQuantity', 'Sub UOM quantity', false, false, null, false),       DynamicUom: new GridHeaderModel(new HeaderStyles(null, null), 'DynamicUom', 'Dynamic UOM', false, false, null, false),       UomUpc: new GridHeaderModel(new HeaderStyles(null, null), 'UomUpc', 'UOM UPC', false, false, null, false),       UomAllowSale_YN: new GridHeaderModel(new HeaderStyles(null, null), 'UomAllowSale_YN', 'UOM allow sale_yn', false, false, null, false),       UomAllowPurchase_YN: new GridHeaderModel(new HeaderStyles(null, null), 'UomAllowPurchase_YN', 'UOM allow purchase_yn', false, false, null, false),       UomReporting_YN: new GridHeaderModel(new HeaderStyles(null, null), 'UomReporting_YN', 'UOM reporting_yn', false, false, null, false),       UomNonDefault_YN: new GridHeaderModel(new HeaderStyles(null, null), 'UomNonDefault_YN', 'UOM non default_yn', false, false, null, false),       UomPalletTie: new GridHeaderModel(new HeaderStyles(null, null), 'UomPalletTie', 'UOM pallet tie', false, false, null, false),       UomPalletHigh: new GridHeaderModel(new HeaderStyles(null, null), 'UomPalletHigh', 'UOM pallet high', false, false, null, false),       UomStandardPrice: new GridHeaderModel(new HeaderStyles(null, null), 'UomStandardPrice', 'UOM standard price', false, false, null, false),       UomStandardCost: new GridHeaderModel(new HeaderStyles(null, null), 'UomStandardCost', 'UOM standard cost', false, false, null, false),       UomWeight: new GridHeaderModel(new HeaderStyles(null, null), 'UomWeight', 'UOM weight', false, false, null, false),       UomShippingWeight: new GridHeaderModel(new HeaderStyles(null, null), 'UomShippingWeight', 'UOM shipping weight', false, false, null, false),       UomLength: new GridHeaderModel(new HeaderStyles(null, null), 'UomLength', 'UOM length', false, false, null, false),       UomWidth: new GridHeaderModel(new HeaderStyles(null, null), 'UomWidth', 'UOM width', false, false, null, false),       UomHeight: new GridHeaderModel(new HeaderStyles(null, null), 'UomHeight', 'UOM height', false, false, null, false),       UomVolume: new GridHeaderModel(new HeaderStyles(null, null), 'UomVolume', 'UOM volume', false, false, null, false),       UomWeightUnit: new GridHeaderModel(new HeaderStyles(null, null), 'UomWeightUnit', 'UOM weight unit', false, false, null, false),       UomDimensionUnit: new GridHeaderModel(new HeaderStyles(null, null), 'UomDimensionUnit', 'UOM dimension unit', false, false, null, false),       UomVolumeUnit: new GridHeaderModel(new HeaderStyles(null, null), 'UomVolumeUnit', 'UOM volume unit', false, false, null, false),       ManufacturingCrewComplement: new GridHeaderModel(new HeaderStyles(null, null), 'ManufacturingCrewComplement', 'Manufacturing crew complement', false, false, null, false),       LpMixingRestriction: new GridHeaderModel(new HeaderStyles(null, null), 'LpMixingRestriction', 'LP mixing restriction', false, false, null, false),       AutoPopulateLot: new GridHeaderModel(new HeaderStyles(null, null), 'AutoPopulateLot', 'Auto populate lot', false, false, null, false),       AutoPopulateVendorLot: new GridHeaderModel(new HeaderStyles(null, null), 'AutoPopulateVendorLot', 'Auto populate vendor lot', false, false, null, false),       MaterialTagList: new GridHeaderModel(new HeaderStyles(null, null), 'MaterialTagList', 'Material tag list', false, false, null, false),       UDF01Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF01Name', 'UDF 01 name', false, false, null, false),       UDF01Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF01Value', 'UDF 01 value', false, false, null, false),       UDF02Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF02Name', 'UDF 02 name', false, false, null, false),       UDF02Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF02Value', 'UDF 02 value', false, false, null, false),       UDF03Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF03Name', 'UDF 03 name', false, false, null, false),       UDF03Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF03Value', 'UDF 03 value', false, false, null, false),       UDF04Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF04Name', 'UDF 04 name', false, false, null, false),       UDF04Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF04Value', 'UDF 04 value', false, false, null, false),       UDF05Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF05Name', 'UDF 05 name', false, false, null, false),       UDF05Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF05Value', 'UDF 05 value', false, false, null, false),       UDF06Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF06Name', 'UDF 06 name', false, false, null, false),       UDF06Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF06Value', 'UDF 06 value', false, false, null, false),       UDF07Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF07Name', 'UDF 07 name', false, false, null, false),       UDF07Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF07Value', 'UDF07Value', false, false, null, false),       UDF08Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF08Name', 'UDF 08 name', false, false, null, false),       UDF08Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF08Value', 'UDF 08 value', false, false, null, false),       UDF09Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF09Name', 'UDF 09 name', false, false, null, false),       UDF09Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF09Value', 'UDF 09 value', false, false, null, false),       UDF10Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF10Name', 'UDF 10 name', false, false, null, false),       UDF10Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF10Value', 'UDF 10 value', false, false, null, false),       UDF11Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF11Name', 'UDF 11 name', false, false, null, false),       UDF11Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF11Value', 'UDF 11 value', false, false, null, false),       UDF12Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF12Name', 'UDF 12 name', false, false, null, false),       UDF12Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF12Value', 'UDF 12 value', false, false, null, false),       UDF13Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF13Name', 'UDF 13 name', false, false, null, false),       UDF13Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF13Value', 'UDF 13 value', false, false, null, false),       UDF14Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF14Name', 'UDF 14 name', false, false, null, false),       UDF14Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF14Value', 'UDF 14 value', false, false, null, false),       UDF15Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF15Name', 'UDF 15 name', false, false, null, false),       UDF15Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF15Value', 'UDF 15 value', false, false, null, false),       UDF16Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF16Name', 'UDF 16 name', false, false, null, false),       UDF16Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF16Value', 'UDF 16 value', false, false, null, false),       UDF17Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF17Name', 'UDF 17 name', false, false, null, false),       UDF17Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF17Value', 'UDF 17 value', false, false, null, false),       UDF18Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF18Name', 'UDF 18 name', false, false, null, false),       UDF18Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF18Value', 'UDF 18 value', false, false, null, false),       UDF19Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF19Name', 'UDF 19 name', false, false, null, false),       UDF19Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF19Value', 'UDF 19 value', false, false, null, false),       UDF20Name: new GridHeaderModel(new HeaderStyles(null, null), 'UDF20Name', 'UDF 20 name', false, false, null, false),       UDF20Value: new GridHeaderModel(new HeaderStyles(null, null), 'UDF20Value', 'UDF 20 value', false, false, null, false),       json_test: new GridHeaderModel(new HeaderStyles(null, null), 'json_test', 'json_test', false, false, null, false),       xml_test: new GridHeaderModel(new HeaderStyles(null, null), 'xml_test', 'xml_test', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: ExcelMaterialImport_excel_material_import_staging_gridComponentRowModel[] = [];


  topToolbar = {
      run_import: new ToolModel(new ButtonModel('run_import', new ButtonStyles(['creation'], null), false, false, false, 'Submit to entity import', 'icon-ic_fluent_play_20_regular', null)
    , false),
      confirm_entity_import: new ToolModel(new ButtonModel('confirm_entity_import', new ButtonStyles(null, null), false, false, false, 'Confirm entity import', 'icon-ic_fluent_checkmark_20_filled', null)
    , false),
      line_count: new ToolModel(new ButtonModel('line_count', new ButtonStyles(null, null), false, false, false, 'Line count', '', null)
    , false),
      separator1: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      delete_row: new ToolModel(new ButtonModel('delete_row', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false),
      purge_data: new ToolModel(new ButtonModel('purge_data', new ButtonStyles(null, null), false, false, false, 'Purge table', 'icon-ic_fluent_delete_20_regular', null)
    , false),
      separator2: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      submitted: new ToolModel(new ButtonModel('submitted', new ButtonStyles(null, null), false, false, false, 'Submitted', '', null)
    , false),
      ready: new ToolModel(new ButtonModel('ready', new ButtonStyles(['creation'], null), false, false, false, 'Ready', '', null)
    , false),
      errors: new ToolModel(new ButtonModel('errors', new ButtonStyles(['destructive'], null), false, false, false, 'Error', '', null)
    , false),
      separator3: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      refresh: new ToolModel(new ButtonModel('refresh', new ButtonStyles(null, null), false, false, false, ' ', 'icon-ic_fluent_arrow_clockwise_20_regular', () => { const $utils = this.$utils; const $grid = this; return 'Refresh'; })
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };

  formGroup: FormGroup = new FormGroup({
    import_status: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    import_status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['import_status'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Import status', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: ExcelMaterialImport_ShellService,
    private $datasources: ExcelMaterialImport_DatasourceService,
    private $flows: ExcelMaterialImport_FlowService,
    private $reports: ExcelMaterialImport_ReportService,
    private $localization: ExcelMaterialImport_LocalizationService,
    private $operations: ExcelMaterialImport_OperationService,
    private $logger: CleanupLoggerService,
    private $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Excel material import staging';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      import_status:  $grid.filters.import_status.control.value ,
      full_text_search:  $grid.fullTextSearch ,
    };
    try {
      const data = await this.$datasources.ExcelMaterialImport.ds_material_import_staging_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IExcelMaterialImport_excel_material_import_staging_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new ExcelMaterialImport_excel_material_import_staging_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: ExcelMaterialImport_excel_material_import_staging_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  async addRow(entity?: IExcelMaterialImport_excel_material_import_staging_gridComponentEntity) {
    const row = new ExcelMaterialImport_excel_material_import_staging_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_excel_export(event = null) {
    return this.on_excel_exportInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_exportInternal(
    $grid: ExcelMaterialImport_excel_material_import_staging_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/17/2024
  
  const wb = $event;
  
  let material_records = [];
  
  let we_have_rows: boolean = false;
  let export_template: boolean = true;
  
  if ($utils.isDefined($grid.rows)) {
      we_have_rows = true;
  }
  
  if (we_have_rows) {
      export_template = (await $shell.ExcelMaterialImport.openConfirmationDialog("Export", "Please select if you want to export the template or the current results of the grid.", "Export template", "Current results"))
  }
  
  if (export_template) {
  
      material_records = [];
  
      material_records.push({
          LookupCode: 'Widget',
          OwnerLookupCode: 'TemplateOwner',
          ProjectLookupCode: 'TemplateOwner',
          GlobalMaterialName: 'Widget',
          MaterialName: 'Widget Name',
          MaterialDescription: 'This is a sample material for import.',
          MaterialGroup: 'No Group',
          MaterialStatus: 'Active',
          ReceiveStatus: 'Active',
          NmfcNumber: '',
          NmfcSubNumber: '',
          LotControlled_YN: 'Y',
          SerialControlled_YN: 'N',
          FixedWeight_YN: 'Y',
          FixedDimension_YN: 'Y',
          FixedVolume_YN: 'Y',
          AllowReceiving_YN: 'Y',
          AllowShipping_YN: 'Y',
          AllowReturns_YN: 'Y',
          AllowBlindReceiving_YN: 'Y',
          SkipLpFifoAllocation_YN: 'N',
          IncludeInCycleCount_YN: 'Y',
          KitType: 'None',
          CurrencyId: 'USD',
          ShelfLifeDays: '',
          MinimumDays: '',
          StandardPrice: '',
          StandardCost: '',
          AllocationStrategy: '',
          PackageAllocationStrategy: '',
          DaysToFirstTasteTest: '',
          TasteTestCycleDays: '',
          ReallocationExpirationWindow: '',
          PrimaryPickLocationsPerWarehouse: '',
          ReceivingOverageThreshold: '',
          StandardUnitsPerHour: '',
          AmbientTimeInHours: '',
          CycleCountTolerance: '',
          StorageCategoryRule: '',
          Uom: 'EA',
          SubUom: '',
          SubUomQuantity: '',
          DynamicUom: '',
          UomUpc: '12345678901234',
          UomAllowSale_YN: '',
          UomAllowPurchase_YN: '',
          UomReporting_YN: '',
          UomNondefault_YN: '',
          UomPalletTie: '',
          UomPalletHigh: '',
          UomStandardPrice: '',
          UomStandardCost: '',
          UomWeight: '1.5',
          UomShippingWeight: '1.6',
          UomLength: '',
          UomWidth: '',
          UomHeight: '',
          UomVolume: '',
          UomShippingVolume: '',
          UomWeightUnit: 'lb',
          UomDimensionUnit: '',
          UomVolumeUnit: '',
          ManufacturingCrewComplement: '',
          LpMixingRestriction: '',
          AutoPopulateLot: '',
          AutoPopulateVendorLot: '',
          MaterialTagList: '',
          UDF01Name: '',
          UDF01Value: '',
          UDF02Name: '',
          UDF02Value: '',
          UDF03Name: '',
          UDF03Value: '',
          UDF04Name: '',
          UDF04Value: '',
          UDF05Name: '',
          UDF05Value: '',
          UDF06Name: '',
          UDF06Value: '',
          UDF07Name: '',
          UDF07Value: '',
          UDF08Name: '',
          UDF08Value: '',
          UDF09Name: '',
          UDF09Value: '',
          UDF10Name: '',
          UDF10Value: '',
          UDF11Name: '',
          UDF11Value: '',
          UDF12Name: '',
          UDF12Value: '',
          UDF13Name: '',
          UDF13Value: '',
          UDF14Name: '',
          UDF14Value: '',
          UDF15Name: '',
          UDF15Value: '',
          UDF16Name: '',
          UDF16Value: '',
          UDF17Name: '',
          UDF17Value: '',
          UDF18Name: '',
          UDF18Value: '',
          UDF19Name: '',
          UDF19Value: '',
          UDF20Name: '',
          UDF20Value: ''
      });
  
      material_records.push({
          LookupCode: 'Widget',
          OwnerLookupCode: 'TemplateOwner',
          ProjectLookupCode: 'TemplateOwner',
          GlobalMaterialName: 'Widget',
          MaterialName: 'Widget Name',
          MaterialDescription: 'This is a sample material for import.',
          MaterialGroup: 'No Group',
          MaterialStatus: 'Active',
          ReceiveStatus: 'Active',
          NmfcNumber: '',
          NmfcSubNumber: '',
          LotControlled_YN: 'Y',
          SerialControlled_YN: 'N',
          FixedWeight_YN: 'Y',
          FixedDimension_YN: 'Y',
          FixedVolume_YN: 'Y',
          AllowReceiving_YN: 'Y',
          AllowShipping_YN: 'Y',
          AllowReturns_YN: 'Y',
          AllowBlindReceiving_YN: 'Y',
          SkipLpFifoAllocation_YN: 'N',
          IncludeInCycleCount_YN: 'Y',
          KitType: 'None',
          CurrencyId: 'USD',
          ShelfLifeDays: '',
          MinimumDays: '',
          StandardPrice: '',
          StandardCost: '',
          AllocationStrategy: '',
          PackageAllocationStrategy: '',
          DaysToFirstTasteTest: '',
          TasteTestCycleDays: '',
          ReallocationExpirationWindow: '',
          PrimaryPickLocationsPerWarehouse: '',
          ReceivingOverageThreshold: '',
          StandardUnitsPerHour: '',
          AmbientTimeInHours: '',
          CycleCountTolerance: '',
          StorageCategoryRule: '',
          Uom: 'CA',
          SubUom: 'EA',
          SubUomQuantity: '16',
          DynamicUom: '',
          UomUpc: '12345678901235',
          UomAllowSale_YN: '',
          UomAllowPurchase_YN: '',
          UomReporting_YN: '',
          UomNondefault_YN: '',
          UomPalletTie: '',
          UomPalletHigh: '',
          UomStandardPrice: '',
          UomStandardCost: '',
          UomWeight: '24',
          UomShippingWeight: '25.6',
          UomLength: '',
          UomWidth: '',
          UomHeight: '',
          UomVolume: '',
          UomShippingVolume: '',
          UomWeightUnit: 'lb',
          UomDimensionUnit: '',
          UomVolumeUnit: '',
          ManufacturingCrewComplement: '',
          LpMixingRestriction: '',
          AutoPopulateLot: '',
          AutoPopulateVendorLot: '',
          MaterialTagList: '',
          UDF01Name: '',
          UDF01Value: '',
          UDF02Name: '',
          UDF02Value: '',
          UDF03Name: '',
          UDF03Value: '',
          UDF04Name: '',
          UDF04Value: '',
          UDF05Name: '',
          UDF05Value: '',
          UDF06Name: '',
          UDF06Value: '',
          UDF07Name: '',
          UDF07Value: '',
          UDF08Name: '',
          UDF08Value: '',
          UDF09Name: '',
          UDF09Value: '',
          UDF10Name: '',
          UDF10Value: '',
          UDF11Name: '',
          UDF11Value: '',
          UDF12Name: '',
          UDF12Value: '',
          UDF13Name: '',
          UDF13Value: '',
          UDF14Name: '',
          UDF14Value: '',
          UDF15Name: '',
          UDF15Value: '',
          UDF16Name: '',
          UDF16Value: '',
          UDF17Name: '',
          UDF17Value: '',
          UDF18Name: '',
          UDF18Value: '',
          UDF19Name: '',
          UDF19Value: '',
          UDF20Name: '',
          UDF20Value: ''
      });
  } else {
  
      let import_status: string = $grid.filters.import_status.control.value;
      let full_text_search: string = $grid.fullTextSearch;
  
      let skip: number = 0;
      let take: number = 2500;
      let current: number = 1;
  
      while (current > 0) {
  
          let current_payload = (await $flows.ExcelMaterialImport.material_import_staging({
              action: "Read",
              import_status: import_status,
              full_text_search: full_text_search,
              skip: skip,
              take: take
          })).payload;
  
          if ($utils.isDefined(current_payload)) {
              current = current_payload.length;
              material_records.push(...current_payload);
  
              if (current < take) {
                  current = 0
              } else {
                  skip = skip + take;
              }
          } else {
              current = 0;
          }
      }
  }
  
  if ($utils.isDefined(material_records)) {
  
      const ws = $utils.excel.json_to_sheet(material_records);
      $utils.excel.book_append_sheet(wb, ws, 'MaterialImportStaging');
  }
  }
  on_excel_import(event = null) {
    return this.on_excel_importInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_importInternal(
    $grid: ExcelMaterialImport_excel_material_import_staging_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/13/2024
  
  const wb = $event;
  const wsname = wb.SheetNames[0];
  const ws = wb.Sheets[wsname];
  
  $grid.topToolbar.line_count.hidden = false;
  $grid.topToolbar.line_count.control.icon = "icon datex-default-spinner";
  $grid.topToolbar.line_count.control.label = 'Extracting data...';
  
  const Materials = $utils.excel.sheet_to_json<{
      LookupCode: string,
      OwnerLookupCode: string,
      ProjectLookupCode: string,
      GlobalMaterialName: string,
      MaterialName: string,
      MaterialDescription: string,
      MaterialGroup: string,
      MaterialStatus: string,
      ReceiveStatus: string,
      NmfcNumber: string,
      NmfcSubNumber: string,
      LotControlled_YN: string,
      SerialControlled_YN: string,
      FixedWeight_YN: string,
      FixedDimension_YN: string,
      FixedVolume_YN: string,
      AllowReceiving_YN: string,
      AllowShipping_YN: string,
      AllowReturns_YN: string,
      AllowBlindReceiving_YN: string,
      SkipLpFifoAllocation_YN: string,
      IncludeInCycleCount_YN: string,
      KitType: string,
      CurrencyId: string,
      ShelfLifeDays: string,
      MinimumDays: string,
      StandardPrice: string,
      StandardCost: string,
      AllocationStrategy: string,
      PackageAllocationStrategy: string,
      DaysToFirstTasteTest: string,
      TasteTestCycleDays: string,
      ReallocationExpirationWindow: string,
      PrimaryPickLocationsPerWarehouse: string,
      ReceivingOverageThreshold: string,
      StandardUnitsPerHour: string,
      AmbientTimeInHours: string,
      CycleCountTolerance: string,
      StorageCategoryRule: string,
      Uom: string,
      SubUom: string,
      SubUomQuantity: string,
      DynamicUom: string,
      UomUpc: string,
      UomAllowSale_YN: string,
      UomAllowPurchase_YN: string,
      UomReporting_YN: string,
      UomNonDefault_YN: string,
      UomPalletTie: string,
      UomPalletHigh: string,
      UomStandardPrice: string,
      UomStandardCost: string,
      UomWeight: string,
      UomShippingWeight: string,
      UomLength: string,
      UomWidth: string,
      UomHeight: string,
      UomVolume: string,
      UomShippingVolume: string,
      UomWeightUnit: string,
      UomDimensionUnit: string,
      UomVolumeUnit: string,
      ManufacturingCrewComplement: string,
      LpMixingRestriction: string,
      AutoPopulateLot: string,
      AutoPopulateVendorLot: string,
      MaterialTagList: string,
      UDF01Name: string,
      UDF01Value: string,
      UDF02Name: string,
      UDF02Value: string,
      UDF03Name: string,
      UDF03Value: string,
      UDF04Name: string,
      UDF04Value: string,
      UDF05Name: string,
      UDF05Value: string,
      UDF06Name: string,
      UDF06Value: string,
      UDF07Name: string,
      UDF07Value: string,
      UDF08Name: string,
      UDF08Value: string,
      UDF09Name: string,
      UDF09Value: string,
      UDF10Name: string,
      UDF10Value: string,
      UDF11Name: string,
      UDF11Value: string,
      UDF12Name: string,
      UDF12Value: string,
      UDF13Name: string,
      UDF13Value: string,
      UDF14Name: string,
      UDF14Value: string,
      UDF15Name: string,
      UDF15Value: string,
      UDF16Name: string,
      UDF16Value: string,
      UDF17Name: string,
      UDF17Value: string,
      UDF18Name: string,
      UDF18Value: string,
      UDF19Name: string,
      UDF19Value: string,
      UDF20Name: string,
      UDF20Value: string
  }>(ws);
  
  let input_payload: $types.ExcelMaterialImport.MaterialImportRecord[] = [];
  let input_errors: { LookupCode: string, ErrorMessage: string }[] = [];
  
  for (let Material of Materials) {
  
      try {
  
          let CleanRecord = JSON.parse(JSON.stringify(Material));
          CleanRecord = clean_record(CleanRecord)
  
          if ($utils.isDefined(CleanRecord)) {
              input_payload.push(CleanRecord)
          }
  
      } catch (error) {
          input_errors.push({ LookupCode: Material.LookupCode, ErrorMessage: get_error(error) });
      }
  }
  
  if (input_errors.length > 0) {
      await $shell.ExcelMaterialImport.openErrorDialog("Error processing some rows", input_errors.map(i => `${i.LookupCode}: ${i.ErrorMessage}`).join(". "))
  }
  
  let count: number = input_payload?.length ?? 0;
  
  if (count === 0) {
  
      await $shell.ExcelMaterialImport.openErrorDialog("Error reading data", "No records were loaded.");
  
  } else {
  
      $grid.topToolbar.line_count.control.label = 'Staging data...';
  
      let write_to_staging = (await $flows.ExcelMaterialImport.material_import_staging({
          action: "Write",
          payload: input_payload
      }));
  
      if (!write_to_staging.success) {
  
          await $shell.ExcelMaterialImport.openErrorDialog("Error staging data", write_to_staging.messages.join(""));
      }
  }
  
  $grid.topToolbar.line_count.control.icon = null;
  $grid.topToolbar.line_count.control.label = 'Ready for import';
  $grid.filters.import_status.control.value = 'Ready';
  
  await $grid.refresh();
  
  function clean_record(candidate: $types.ExcelMaterialImport.MaterialImportRecord) {
  
      delete candidate["Id"]
      delete candidate["ImportStatus"]
      delete candidate["ImportCreatedDate"]
      delete candidate["ImportCompletedDate"]
      delete candidate["ImportErrorMessage"]
      delete candidate["ImportRequestId"]
  
      if (!$utils.isDefined(candidate.LookupCode)) { delete candidate["LookupCode"] }
      if (!$utils.isDefined(candidate.OwnerLookupCode)) { delete candidate["OwnerLookupCode"] }
      if (!$utils.isDefined(candidate.ProjectLookupCode)) { delete candidate["ProjectLookupCode"] }
      if (!$utils.isDefined(candidate.GlobalMaterialName)) { delete candidate["GlobalMaterialName"] }
      if (!$utils.isDefined(candidate.MaterialName)) { delete candidate["MaterialName"] }
      if (!$utils.isDefined(candidate.MaterialDescription)) { delete candidate["MaterialDescription"] }
      if (!$utils.isDefined(candidate.MaterialGroup)) { delete candidate["MaterialGroup"] }
      if (!$utils.isDefined(candidate.MaterialStatus)) { delete candidate["MaterialStatus"] }
      if (!$utils.isDefined(candidate.ReceiveStatus)) { delete candidate["ReceiveStatus"] }
      if (!$utils.isDefined(candidate.NmfcNumber)) { delete candidate["NmfcNumber"] }
      if (!$utils.isDefined(candidate.NmfcSubNumber)) { delete candidate["NmfcSubNumber"] }
      if (!$utils.isDefined(candidate.LotControlled_YN)) { delete candidate["LotControlled_YN"] }
      if (!$utils.isDefined(candidate.SerialControlled_YN)) { delete candidate["SerialControlled_YN"] }
      if (!$utils.isDefined(candidate.FixedWeight_YN)) { delete candidate["FixedWeight_YN"] }
      if (!$utils.isDefined(candidate.FixedDimension_YN)) { delete candidate["FixedDimension_YN"] }
      if (!$utils.isDefined(candidate.FixedVolume_YN)) { delete candidate["FixedVolume_YN"] }
      if (!$utils.isDefined(candidate.AllowReceiving_YN)) { delete candidate["AllowReceiving_YN"] }
      if (!$utils.isDefined(candidate.AllowShipping_YN)) { delete candidate["AllowShipping_YN"] }
      if (!$utils.isDefined(candidate.AllowReturns_YN)) { delete candidate["AllowReturns_YN"] }
      if (!$utils.isDefined(candidate.AllowBlindReceiving_YN)) { delete candidate["AllowBlindReceiving_YN"] }
      if (!$utils.isDefined(candidate.SkipLpFifoAllocation_YN)) { delete candidate["SkipLpFifoAllocation_YN"] }
      if (!$utils.isDefined(candidate.IncludeInCycleCount_YN)) { delete candidate["IncludeInCycleCount_YN"] }
      if (!$utils.isDefined(candidate.KitType)) { delete candidate["KitType"] }
      if (!$utils.isDefined(candidate.CurrencyId)) { delete candidate["CurrencyId"] }
      if (!$utils.isDefined(candidate.ShelfLifeDays)) { delete candidate["ShelfLifeDays"] }
      if (!$utils.isDefined(candidate.MinimumDays)) { delete candidate["MinimumDays"] }
      if (!$utils.isDefined(candidate.StandardPrice)) { delete candidate["StandardPrice"] }
      if (!$utils.isDefined(candidate.StandardCost)) { delete candidate["StandardCost"] }
      if (!$utils.isDefined(candidate.AllocationStrategy)) { delete candidate["AllocationStrategy"] }
      if (!$utils.isDefined(candidate.PackageAllocationStrategy)) { delete candidate["PackageAllocationStrategy"] }
      if (!$utils.isDefined(candidate.DaysToFirstTasteTest)) { delete candidate["DaysToFirstTasteTest"] }
      if (!$utils.isDefined(candidate.TasteTestCycleDays)) { delete candidate["TasteTestCycleDays"] }
      if (!$utils.isDefined(candidate.ReallocationExpirationWindow)) { delete candidate["ReallocationExpirationWindow"] }
      if (!$utils.isDefined(candidate.PrimaryPickLocationsPerWarehouse)) { delete candidate["PrimaryPickLocationsPerWarehouse"] }
      if (!$utils.isDefined(candidate.ReceivingOverageThreshold)) { delete candidate["ReceivingOverageThreshold"] }
      if (!$utils.isDefined(candidate.StandardUnitsPerHour)) { delete candidate["StandardUnitsPerHour"] }
      if (!$utils.isDefined(candidate.AmbientTimeInHours)) { delete candidate["AmbientTimeInHours"] }
      if (!$utils.isDefined(candidate.CycleCountTolerance)) { delete candidate["CycleCountTolerance"] }
      if (!$utils.isDefined(candidate.StorageCategoryRule)) { delete candidate["StorageCategoryRule"] }
      if (!$utils.isDefined(candidate.Uom)) { delete candidate["Uom"] }
      if (!$utils.isDefined(candidate.SubUom)) { delete candidate["SubUom"] }
      if (!$utils.isDefined(candidate.SubUomQuantity)) { delete candidate["SubUomQuantity"] }
      if (!$utils.isDefined(candidate.DynamicUom)) { delete candidate["DynamicUom"] }
      if (!$utils.isDefined(candidate.UomUpc)) { delete candidate["UomUpc"] }
      if (!$utils.isDefined(candidate.UomAllowSale_YN)) { delete candidate["UomAllowSale_YN"] }
      if (!$utils.isDefined(candidate.UomAllowPurchase_YN)) { delete candidate["UomAllowPurchase_YN"] }
      if (!$utils.isDefined(candidate.UomReporting_YN)) { delete candidate["UomReporting_YN"] }
      if (!$utils.isDefined(candidate.UomNonDefault_YN)) { delete candidate["UomNonDefault_YN"] }
      if (!$utils.isDefined(candidate.UomPalletTie)) { delete candidate["UomPalletTie"] }
      if (!$utils.isDefined(candidate.UomPalletHigh)) { delete candidate["UomPalletHigh"] }
      if (!$utils.isDefined(candidate.UomStandardPrice)) { delete candidate["UomStandardPrice"] }
      if (!$utils.isDefined(candidate.UomStandardCost)) { delete candidate["UomStandardCost"] }
      if (!$utils.isDefined(candidate.UomWeight)) { delete candidate["UomWeight"] }
      if (!$utils.isDefined(candidate.UomShippingWeight)) { delete candidate["UomShippingWeight"] }
      if (!$utils.isDefined(candidate.UomLength)) { delete candidate["UomLength"] }
      if (!$utils.isDefined(candidate.UomWidth)) { delete candidate["UomWidth"] }
      if (!$utils.isDefined(candidate.UomHeight)) { delete candidate["UomHeight"] }
      if (!$utils.isDefined(candidate.UomVolume)) { delete candidate["UomVolume"] }
      if (!$utils.isDefined(candidate.UomShippingVolume)) { delete candidate["UomShippingVolume"] }
      if (!$utils.isDefined(candidate.UomWeightUnit)) { delete candidate["UomWeightUnit"] }
      if (!$utils.isDefined(candidate.UomDimensionUnit)) { delete candidate["UomDimensionUnit"] }
      if (!$utils.isDefined(candidate.UomVolumeUnit)) { delete candidate["UomVolumeUnit"] }
      if (!$utils.isDefined(candidate.ManufacturingCrewComplement)) { delete candidate["ManufacturingCrewComplement"] }
      if (!$utils.isDefined(candidate.LpMixingRestriction)) { delete candidate["LpMixingRestriction"] }
      if (!$utils.isDefined(candidate.AutoPopulateLot)) { delete candidate["AutoPopulateLot"] }
      if (!$utils.isDefined(candidate.AutoPopulateVendorLot)) { delete candidate["AutoPopulateVendorLot"] }
      if (!$utils.isDefined(candidate.MaterialTagList)) { delete candidate["MaterialTagList"] }
      if (!$utils.isDefined(candidate.UDF01Name)) { delete candidate["UDF01Name"] }
      if (!$utils.isDefined(candidate.UDF01Value)) { delete candidate["UDF01Value"] }
      if (!$utils.isDefined(candidate.UDF02Name)) { delete candidate["UDF02Name"] }
      if (!$utils.isDefined(candidate.UDF02Value)) { delete candidate["UDF02Value"] }
      if (!$utils.isDefined(candidate.UDF03Name)) { delete candidate["UDF03Name"] }
      if (!$utils.isDefined(candidate.UDF03Value)) { delete candidate["UDF03Value"] }
      if (!$utils.isDefined(candidate.UDF04Name)) { delete candidate["UDF04Name"] }
      if (!$utils.isDefined(candidate.UDF04Value)) { delete candidate["UDF04Value"] }
      if (!$utils.isDefined(candidate.UDF05Name)) { delete candidate["UDF05Name"] }
      if (!$utils.isDefined(candidate.UDF05Value)) { delete candidate["UDF05Value"] }
      if (!$utils.isDefined(candidate.UDF06Name)) { delete candidate["UDF06Name"] }
      if (!$utils.isDefined(candidate.UDF06Value)) { delete candidate["UDF06Value"] }
      if (!$utils.isDefined(candidate.UDF07Name)) { delete candidate["UDF07Name"] }
      if (!$utils.isDefined(candidate.UDF07Value)) { delete candidate["UDF07Value"] }
      if (!$utils.isDefined(candidate.UDF08Name)) { delete candidate["UDF08Name"] }
      if (!$utils.isDefined(candidate.UDF08Value)) { delete candidate["UDF08Value"] }
      if (!$utils.isDefined(candidate.UDF09Name)) { delete candidate["UDF09Name"] }
      if (!$utils.isDefined(candidate.UDF09Value)) { delete candidate["UDF09Value"] }
      if (!$utils.isDefined(candidate.UDF10Name)) { delete candidate["UDF10Name"] }
      if (!$utils.isDefined(candidate.UDF10Value)) { delete candidate["UDF10Value"] }
      if (!$utils.isDefined(candidate.UDF11Name)) { delete candidate["UDF11Name"] }
      if (!$utils.isDefined(candidate.UDF11Value)) { delete candidate["UDF11Value"] }
      if (!$utils.isDefined(candidate.UDF12Name)) { delete candidate["UDF12Name"] }
      if (!$utils.isDefined(candidate.UDF12Value)) { delete candidate["UDF12Value"] }
      if (!$utils.isDefined(candidate.UDF13Name)) { delete candidate["UDF13Name"] }
      if (!$utils.isDefined(candidate.UDF13Value)) { delete candidate["UDF13Value"] }
      if (!$utils.isDefined(candidate.UDF14Name)) { delete candidate["UDF14Name"] }
      if (!$utils.isDefined(candidate.UDF14Value)) { delete candidate["UDF14Value"] }
      if (!$utils.isDefined(candidate.UDF15Name)) { delete candidate["UDF15Name"] }
      if (!$utils.isDefined(candidate.UDF15Value)) { delete candidate["UDF15Value"] }
      if (!$utils.isDefined(candidate.UDF16Name)) { delete candidate["UDF16Name"] }
      if (!$utils.isDefined(candidate.UDF16Value)) { delete candidate["UDF16Value"] }
      if (!$utils.isDefined(candidate.UDF17Name)) { delete candidate["UDF17Name"] }
      if (!$utils.isDefined(candidate.UDF17Value)) { delete candidate["UDF17Value"] }
      if (!$utils.isDefined(candidate.UDF18Name)) { delete candidate["UDF18Name"] }
      if (!$utils.isDefined(candidate.UDF18Value)) { delete candidate["UDF18Value"] }
      if (!$utils.isDefined(candidate.UDF19Name)) { delete candidate["UDF19Name"] }
      if (!$utils.isDefined(candidate.UDF19Value)) { delete candidate["UDF19Value"] }
      if (!$utils.isDefined(candidate.UDF20Name)) { delete candidate["UDF20Name"] }
      if (!$utils.isDefined(candidate.UDF20Value)) { delete candidate["UDF20Value"] }
  
      if ($utils.isDefined(candidate.LookupCode)) { candidate.LookupCode = validate_string_value(candidate.LookupCode) }
      if ($utils.isDefined(candidate.OwnerLookupCode)) { candidate.OwnerLookupCode = validate_string_value(candidate.OwnerLookupCode) }
      if ($utils.isDefined(candidate.ProjectLookupCode)) { candidate.ProjectLookupCode = validate_string_value(candidate.ProjectLookupCode) }
      if ($utils.isDefined(candidate.GlobalMaterialName)) { candidate.GlobalMaterialName = validate_string_value(candidate.GlobalMaterialName) }
      if ($utils.isDefined(candidate.MaterialName)) { candidate.MaterialName = validate_string_value(candidate.MaterialName) }
      if ($utils.isDefined(candidate.MaterialDescription)) { candidate.MaterialDescription = validate_string_value(candidate.MaterialDescription) }
      if ($utils.isDefined(candidate.MaterialGroup)) { candidate.MaterialGroup = validate_string_value(candidate.MaterialGroup) }
      if ($utils.isDefined(candidate.MaterialStatus)) { candidate.MaterialStatus = validate_string_value(candidate.MaterialStatus) }
      if ($utils.isDefined(candidate.ReceiveStatus)) { candidate.ReceiveStatus = validate_string_value(candidate.ReceiveStatus) }
      if ($utils.isDefined(candidate.NmfcNumber)) { candidate.NmfcNumber = validate_string_value(candidate.NmfcNumber) }
      if ($utils.isDefined(candidate.NmfcSubNumber)) { candidate.NmfcSubNumber = validate_string_value(candidate.NmfcSubNumber) }
      if ($utils.isDefined(candidate.LotControlled_YN)) { candidate.LotControlled_YN = validate_string_value(candidate.LotControlled_YN) }
      if ($utils.isDefined(candidate.SerialControlled_YN)) { candidate.SerialControlled_YN = validate_string_value(candidate.SerialControlled_YN) }
      if ($utils.isDefined(candidate.FixedWeight_YN)) { candidate.FixedWeight_YN = validate_string_value(candidate.FixedWeight_YN) }
      if ($utils.isDefined(candidate.FixedDimension_YN)) { candidate.FixedDimension_YN = validate_string_value(candidate.FixedDimension_YN) }
      if ($utils.isDefined(candidate.FixedVolume_YN)) { candidate.FixedVolume_YN = validate_string_value(candidate.FixedVolume_YN) }
      if ($utils.isDefined(candidate.AllowReceiving_YN)) { candidate.AllowReceiving_YN = validate_string_value(candidate.AllowReceiving_YN) }
      if ($utils.isDefined(candidate.AllowShipping_YN)) { candidate.AllowShipping_YN = validate_string_value(candidate.AllowShipping_YN) }
      if ($utils.isDefined(candidate.AllowReturns_YN)) { candidate.AllowReturns_YN = validate_string_value(candidate.AllowReturns_YN) }
      if ($utils.isDefined(candidate.AllowBlindReceiving_YN)) { candidate.AllowBlindReceiving_YN = validate_string_value(candidate.AllowBlindReceiving_YN) }
      if ($utils.isDefined(candidate.SkipLpFifoAllocation_YN)) { candidate.SkipLpFifoAllocation_YN = validate_string_value(candidate.SkipLpFifoAllocation_YN) }
      if ($utils.isDefined(candidate.IncludeInCycleCount_YN)) { candidate.IncludeInCycleCount_YN = validate_string_value(candidate.IncludeInCycleCount_YN) }
      if ($utils.isDefined(candidate.KitType)) { candidate.KitType = validate_string_value(candidate.KitType) }
      if ($utils.isDefined(candidate.CurrencyId)) { candidate.CurrencyId = validate_string_value(candidate.CurrencyId) }
      if ($utils.isDefined(candidate.AllocationStrategy)) { candidate.AllocationStrategy = validate_string_value(candidate.AllocationStrategy) }
      if ($utils.isDefined(candidate.PackageAllocationStrategy)) { candidate.PackageAllocationStrategy = validate_string_value(candidate.PackageAllocationStrategy) }
      if ($utils.isDefined(candidate.StorageCategoryRule)) { candidate.StorageCategoryRule = validate_string_value(candidate.StorageCategoryRule) }
      if ($utils.isDefined(candidate.Uom)) { candidate.Uom = validate_string_value(candidate.Uom) }
      if ($utils.isDefined(candidate.SubUom)) { candidate.SubUom = validate_string_value(candidate.SubUom) }
      if ($utils.isDefined(candidate.DynamicUom)) { candidate.DynamicUom = validate_string_value(candidate.DynamicUom) }
      if ($utils.isDefined(candidate.UomUpc)) { candidate.UomUpc = validate_string_value(candidate.UomUpc) }
      if ($utils.isDefined(candidate.UomAllowSale_YN)) { candidate.UomAllowSale_YN = validate_string_value(candidate.UomAllowSale_YN) }
      if ($utils.isDefined(candidate.UomAllowPurchase_YN)) { candidate.UomAllowPurchase_YN = validate_string_value(candidate.UomAllowPurchase_YN) }
      if ($utils.isDefined(candidate.UomReporting_YN)) { candidate.UomReporting_YN = validate_string_value(candidate.UomReporting_YN) }
      if ($utils.isDefined(candidate.UomNonDefault_YN)) { candidate.UomNonDefault_YN = validate_string_value(candidate.UomNonDefault_YN) }
      if ($utils.isDefined(candidate.UomWeightUnit)) { candidate.UomWeightUnit = validate_string_value(candidate.UomWeightUnit) }
      if ($utils.isDefined(candidate.UomDimensionUnit)) { candidate.UomDimensionUnit = validate_string_value(candidate.UomDimensionUnit) }
      if ($utils.isDefined(candidate.UomVolumeUnit)) { candidate.UomVolumeUnit = validate_string_value(candidate.UomVolumeUnit) }
      if ($utils.isDefined(candidate.LpMixingRestriction)) { candidate.LpMixingRestriction = validate_string_value(candidate.LpMixingRestriction) }
      if ($utils.isDefined(candidate.AutoPopulateLot)) { candidate.AutoPopulateLot = validate_string_value(candidate.AutoPopulateLot) }
      if ($utils.isDefined(candidate.AutoPopulateVendorLot)) { candidate.AutoPopulateVendorLot = validate_string_value(candidate.AutoPopulateVendorLot) }
      if ($utils.isDefined(candidate.MaterialTagList)) { candidate.MaterialTagList = validate_string_value(candidate.MaterialTagList) }
      if ($utils.isDefined(candidate.UDF01Name)) { candidate.UDF01Name = validate_string_value(candidate.UDF01Name) }
      if ($utils.isDefined(candidate.UDF01Value)) { candidate.UDF01Value = validate_string_value(candidate.UDF01Value) }
      if ($utils.isDefined(candidate.UDF02Name)) { candidate.UDF02Name = validate_string_value(candidate.UDF02Name) }
      if ($utils.isDefined(candidate.UDF02Value)) { candidate.UDF02Value = validate_string_value(candidate.UDF02Value) }
      if ($utils.isDefined(candidate.UDF03Name)) { candidate.UDF03Name = validate_string_value(candidate.UDF03Name) }
      if ($utils.isDefined(candidate.UDF03Value)) { candidate.UDF03Value = validate_string_value(candidate.UDF03Value) }
      if ($utils.isDefined(candidate.UDF04Name)) { candidate.UDF04Name = validate_string_value(candidate.UDF04Name) }
      if ($utils.isDefined(candidate.UDF04Value)) { candidate.UDF04Value = validate_string_value(candidate.UDF04Value) }
      if ($utils.isDefined(candidate.UDF05Name)) { candidate.UDF05Name = validate_string_value(candidate.UDF05Name) }
      if ($utils.isDefined(candidate.UDF05Value)) { candidate.UDF05Value = validate_string_value(candidate.UDF05Value) }
      if ($utils.isDefined(candidate.UDF06Name)) { candidate.UDF06Name = validate_string_value(candidate.UDF06Name) }
      if ($utils.isDefined(candidate.UDF06Value)) { candidate.UDF06Value = validate_string_value(candidate.UDF06Value) }
      if ($utils.isDefined(candidate.UDF07Name)) { candidate.UDF07Name = validate_string_value(candidate.UDF07Name) }
      if ($utils.isDefined(candidate.UDF07Value)) { candidate.UDF07Value = validate_string_value(candidate.UDF07Value) }
      if ($utils.isDefined(candidate.UDF08Name)) { candidate.UDF08Name = validate_string_value(candidate.UDF08Name) }
      if ($utils.isDefined(candidate.UDF08Value)) { candidate.UDF08Value = validate_string_value(candidate.UDF08Value) }
      if ($utils.isDefined(candidate.UDF09Name)) { candidate.UDF09Name = validate_string_value(candidate.UDF09Name) }
      if ($utils.isDefined(candidate.UDF09Value)) { candidate.UDF09Value = validate_string_value(candidate.UDF09Value) }
      if ($utils.isDefined(candidate.UDF10Name)) { candidate.UDF10Name = validate_string_value(candidate.UDF10Name) }
      if ($utils.isDefined(candidate.UDF10Value)) { candidate.UDF10Value = validate_string_value(candidate.UDF10Value) }
      if ($utils.isDefined(candidate.UDF11Name)) { candidate.UDF11Name = validate_string_value(candidate.UDF11Name) }
      if ($utils.isDefined(candidate.UDF11Value)) { candidate.UDF11Value = validate_string_value(candidate.UDF11Value) }
      if ($utils.isDefined(candidate.UDF12Name)) { candidate.UDF12Name = validate_string_value(candidate.UDF12Name) }
      if ($utils.isDefined(candidate.UDF12Value)) { candidate.UDF12Value = validate_string_value(candidate.UDF12Value) }
      if ($utils.isDefined(candidate.UDF13Name)) { candidate.UDF13Name = validate_string_value(candidate.UDF13Name) }
      if ($utils.isDefined(candidate.UDF13Value)) { candidate.UDF13Value = validate_string_value(candidate.UDF13Value) }
      if ($utils.isDefined(candidate.UDF14Name)) { candidate.UDF14Name = validate_string_value(candidate.UDF14Name) }
      if ($utils.isDefined(candidate.UDF14Value)) { candidate.UDF14Value = validate_string_value(candidate.UDF14Value) }
      if ($utils.isDefined(candidate.UDF15Name)) { candidate.UDF15Name = validate_string_value(candidate.UDF15Name) }
      if ($utils.isDefined(candidate.UDF15Value)) { candidate.UDF15Value = validate_string_value(candidate.UDF15Value) }
      if ($utils.isDefined(candidate.UDF16Name)) { candidate.UDF16Name = validate_string_value(candidate.UDF16Name) }
      if ($utils.isDefined(candidate.UDF16Value)) { candidate.UDF16Value = validate_string_value(candidate.UDF16Value) }
      if ($utils.isDefined(candidate.UDF17Name)) { candidate.UDF17Name = validate_string_value(candidate.UDF17Name) }
      if ($utils.isDefined(candidate.UDF17Value)) { candidate.UDF17Value = validate_string_value(candidate.UDF17Value) }
      if ($utils.isDefined(candidate.UDF18Name)) { candidate.UDF18Name = validate_string_value(candidate.UDF18Name) }
      if ($utils.isDefined(candidate.UDF18Value)) { candidate.UDF18Value = validate_string_value(candidate.UDF18Value) }
      if ($utils.isDefined(candidate.UDF19Name)) { candidate.UDF19Name = validate_string_value(candidate.UDF19Name) }
      if ($utils.isDefined(candidate.UDF19Value)) { candidate.UDF19Value = validate_string_value(candidate.UDF19Value) }
      if ($utils.isDefined(candidate.UDF20Name)) { candidate.UDF20Name = validate_string_value(candidate.UDF20Name) }
      if ($utils.isDefined(candidate.UDF20Value)) { candidate.UDF20Value = validate_string_value(candidate.UDF20Value) }
  
      return candidate;
  }
  
  function get_error(error: any) {
  
      let targetError = error;
      while ($utils.isDefined(targetError?.error)) { targetError = targetError.error }
      if (!$utils.isDefined(targetError?.message)) { targetError = { "message": `Uncaught exception. ${JSON.stringify(targetError)}` } }
  
      return targetError.message;
  }
  
  function validate_string_value(candidate: any) {
      let output: string;
      if ($utils.isDefined(candidate)) {
          if (typeof candidate === "number") {
              output = candidate.toString();
          } else {
              output = candidate;
          }
      }
      return output;
  }
  }
  on_purge_data(event = null) {
    return this.on_purge_dataInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_purge_dataInternal(
    $grid: ExcelMaterialImport_excel_material_import_staging_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/13/2024
  
  let confirm_purge = (await $shell.ExcelMaterialImport.openConfirmationDialog("Purge", "Are you sure you want to purge all the current data in staging?", "Yes", "No"))
  
  if (confirm_purge) {
  
      $grid.topToolbar.line_count.hidden = false;
      $grid.topToolbar.line_count.control.label = 'Purging old data...';
  
      let purge_staging = (await $flows.ExcelMaterialImport.material_import_staging({
          action: "Purge"
      }));
  
      if (!purge_staging.success) {
  
          await $shell.ExcelMaterialImport.openErrorDialog("Error purging staging table", purge_staging.messages.join(""));
  
      }
  
      $grid.topToolbar.line_count.control.icon = null;
      $grid.topToolbar.line_count.control.label = '';
      $grid.topToolbar.line_count.hidden = true;
  
      $grid.refresh();
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: ExcelMaterialImport_excel_material_import_staging_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/20/2024
  
  $grid.topToolbar.delete_row.control.readOnly = true;
  $grid.topToolbar.errors.hidden = true;
  $grid.topToolbar.ready.hidden = true;
  $grid.topToolbar.submitted.hidden = true;
  $grid.topToolbar.line_count.hidden = true;
  $grid.headers.ImportRequestId.hidden = true;
  $grid.headers.Id.hidden = true;
  $grid.headers.json_test.hidden = true;
  $grid.headers.xml_test.hidden = true;
  $grid.vars.running = false;
  $grid.canAdd = false;
  $grid.canEdit = false;
  }
  on_refresh_clicked(event = null) {
    return this.on_refresh_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_refresh_clickedInternal(
    $grid: ExcelMaterialImport_excel_material_import_staging_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/13/2024
  
  $grid.refresh();
  $grid.vars.running = false;
  }
  on_run_clicked(event = null) {
    return this.on_run_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_run_clickedInternal(
    $grid: ExcelMaterialImport_excel_material_import_staging_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/13/2024
  
  if (!$grid.vars.running) {
  
      $grid.vars.running = true;
      $grid.topToolbar.errors.hidden = true;
      $grid.topToolbar.line_count.hidden = false;
      $grid.topToolbar.line_count.control.icon = "icon datex-default-spinner";
      $grid.topToolbar.line_count.control.label = 'Submitting data...';
  
      try {
  
          let run_import = (await $flows.ExcelMaterialImport.material_import_staging_run({}))
  
          if (run_import.success) {
  
              $grid.topToolbar.line_count.control.label = `Data submitted (${run_import.time} sec, ${run_import.runners} runners)`;
  
          } else {
  
              $grid.topToolbar.line_count.control.label = 'Error';
              await $shell.ExcelMaterialImport.openErrorDialog("Error", run_import?.messages?.join(" "))
          }
  
          if (run_import.errors > 0) {
              $grid.topToolbar.errors.hidden = false;
              $grid.topToolbar.errors.control.label = `There were ${run_import.errors} errors.`;
              $grid.filters.import_status.control.value = 'Error'
          }
  
      } catch (error) {
          $grid.topToolbar.line_count.control.label = 'Error';
  
          let targetError = error;
          while ($utils.isDefined(targetError?.error)) { targetError = targetError.error }
          if (!$utils.isDefined(targetError?.message)) { targetError = { "message": `Uncaught exception. ${JSON.stringify(targetError)}` } }
  
          await $shell.ExcelMaterialImport.openErrorDialog("Error", targetError?.message)
      }
  
      $grid.topToolbar.line_count.control.icon = null;
      $grid.vars.running = false;
  }
  
  $flows.ExcelMaterialImport.material_import_staging_confirm({});
  $grid.refresh();
  }
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $grid: ExcelMaterialImport_excel_material_import_staging_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/25/2024
  
  if ($utils.isDefined($grid.rows)) {
  
      let ImportCompletedDate = $grid.rows.filter(r => $utils.isDefined(r.entity.ImportCompletedDate))?.map(r => r.entity.ImportCompletedDate); if ($utils.isDefined(ImportCompletedDate)) { $grid.headers.ImportCompletedDate.hidden = false } else { $grid.headers.ImportCompletedDate.hidden = true }
      let ImportErrorMessage = $grid.rows.filter(r => $utils.isDefined(r.entity.ImportErrorMessage))?.map(r => r.entity.ImportErrorMessage); if ($utils.isDefined(ImportErrorMessage)) { $grid.headers.ImportErrorMessage.hidden = false } else { $grid.headers.ImportErrorMessage.hidden = true }
      //let ImportRequestId = $grid.rows.filter(r => $utils.isDefined(r.entity.ImportRequestId))?.map(r => r.entity.ImportRequestId); if ($utils.isDefined(ImportRequestId)) { $grid.headers.ImportRequestId.hidden = false } else { $grid.headers.ImportRequestId.hidden = true }
      let GlobalMaterialName = $grid.rows.filter(r => $utils.isDefined(r.entity.GlobalMaterialName))?.map(r => r.entity.GlobalMaterialName); if ($utils.isDefined(GlobalMaterialName)) { $grid.headers.GlobalMaterialName.hidden = false } else { $grid.headers.GlobalMaterialName.hidden = true }
      let ReceiveStatus = $grid.rows.filter(r => $utils.isDefined(r.entity.ReceiveStatus))?.map(r => r.entity.ReceiveStatus); if ($utils.isDefined(ReceiveStatus)) { $grid.headers.ReceiveStatus.hidden = false } else { $grid.headers.ReceiveStatus.hidden = true }
      let NmfcNumber = $grid.rows.filter(r => $utils.isDefined(r.entity.NmfcNumber))?.map(r => r.entity.NmfcNumber); if ($utils.isDefined(NmfcNumber)) { $grid.headers.NmfcNumber.hidden = false } else { $grid.headers.NmfcNumber.hidden = true }
      let NmfcSubNumber = $grid.rows.filter(r => $utils.isDefined(r.entity.NmfcSubNumber))?.map(r => r.entity.NmfcSubNumber); if ($utils.isDefined(NmfcSubNumber)) { $grid.headers.NmfcSubNumber.hidden = false } else { $grid.headers.NmfcSubNumber.hidden = true }
      let FixedDimension_YN = $grid.rows.filter(r => $utils.isDefined(r.entity.FixedDimension_YN))?.map(r => r.entity.FixedDimension_YN); if ($utils.isDefined(FixedDimension_YN)) { $grid.headers.FixedDimension_YN.hidden = false } else { $grid.headers.FixedDimension_YN.hidden = true }
      let FixedVolume_YN = $grid.rows.filter(r => $utils.isDefined(r.entity.FixedVolume_YN))?.map(r => r.entity.FixedVolume_YN); if ($utils.isDefined(FixedVolume_YN)) { $grid.headers.FixedVolume_YN.hidden = false } else { $grid.headers.FixedVolume_YN.hidden = true }
      let AllowReceiving_YN = $grid.rows.filter(r => $utils.isDefined(r.entity.AllowReceiving_YN))?.map(r => r.entity.AllowReceiving_YN); if ($utils.isDefined(AllowReceiving_YN)) { $grid.headers.AllowReceiving_YN.hidden = false } else { $grid.headers.AllowReceiving_YN.hidden = true }
      let AllowShipping_YN = $grid.rows.filter(r => $utils.isDefined(r.entity.AllowShipping_YN))?.map(r => r.entity.AllowShipping_YN); if ($utils.isDefined(AllowShipping_YN)) { $grid.headers.AllowShipping_YN.hidden = false } else { $grid.headers.AllowShipping_YN.hidden = true }
      let AllowReturns_YN = $grid.rows.filter(r => $utils.isDefined(r.entity.AllowReturns_YN))?.map(r => r.entity.AllowReturns_YN); if ($utils.isDefined(AllowReturns_YN)) { $grid.headers.AllowReturns_YN.hidden = false } else { $grid.headers.AllowReturns_YN.hidden = true }
      let AllowBlindReceiving_YN = $grid.rows.filter(r => $utils.isDefined(r.entity.AllowBlindReceiving_YN))?.map(r => r.entity.AllowBlindReceiving_YN); if ($utils.isDefined(AllowBlindReceiving_YN)) { $grid.headers.AllowBlindReceiving_YN.hidden = false } else { $grid.headers.AllowBlindReceiving_YN.hidden = true }
      let SkipLpFifoAllocation_YN = $grid.rows.filter(r => $utils.isDefined(r.entity.SkipLpFifoAllocation_YN))?.map(r => r.entity.SkipLpFifoAllocation_YN); if ($utils.isDefined(SkipLpFifoAllocation_YN)) { $grid.headers.SkipLpFifoAllocation_YN.hidden = false } else { $grid.headers.SkipLpFifoAllocation_YN.hidden = true }
      let IncludeInCycleCount_YN = $grid.rows.filter(r => $utils.isDefined(r.entity.IncludeInCycleCount_YN))?.map(r => r.entity.IncludeInCycleCount_YN); if ($utils.isDefined(IncludeInCycleCount_YN)) { $grid.headers.IncludeInCycleCount_YN.hidden = false } else { $grid.headers.IncludeInCycleCount_YN.hidden = true }
      let KitType = $grid.rows.filter(r => $utils.isDefined(r.entity.KitType))?.map(r => r.entity.KitType); if ($utils.isDefined(KitType)) { $grid.headers.KitType.hidden = false } else { $grid.headers.KitType.hidden = true }
      let CurrencyId = $grid.rows.filter(r => $utils.isDefined(r.entity.CurrencyId))?.map(r => r.entity.CurrencyId); if ($utils.isDefined(CurrencyId)) { $grid.headers.CurrencyId.hidden = false } else { $grid.headers.CurrencyId.hidden = true }
      let ShelfLifeDays = $grid.rows.filter(r => $utils.isDefined(r.entity.ShelfLifeDays))?.map(r => r.entity.ShelfLifeDays); if ($utils.isDefined(ShelfLifeDays)) { $grid.headers.ShelfLifeDays.hidden = false } else { $grid.headers.ShelfLifeDays.hidden = true }
      let MinimumDays = $grid.rows.filter(r => $utils.isDefined(r.entity.MinimumDays))?.map(r => r.entity.MinimumDays); if ($utils.isDefined(MinimumDays)) { $grid.headers.MinimumDays.hidden = false } else { $grid.headers.MinimumDays.hidden = true }
      let StandardPrice = $grid.rows.filter(r => $utils.isDefined(r.entity.StandardPrice))?.map(r => r.entity.StandardPrice); if ($utils.isDefined(StandardPrice)) { $grid.headers.StandardPrice.hidden = false } else { $grid.headers.StandardPrice.hidden = true }
      let StandardCost = $grid.rows.filter(r => $utils.isDefined(r.entity.StandardCost))?.map(r => r.entity.StandardCost); if ($utils.isDefined(StandardCost)) { $grid.headers.StandardCost.hidden = false } else { $grid.headers.StandardCost.hidden = true }
      let AllocationStrategy = $grid.rows.filter(r => $utils.isDefined(r.entity.AllocationStrategy))?.map(r => r.entity.AllocationStrategy); if ($utils.isDefined(AllocationStrategy)) { $grid.headers.AllocationStrategy.hidden = false } else { $grid.headers.AllocationStrategy.hidden = true }
      let PackageAllocationStrategy = $grid.rows.filter(r => $utils.isDefined(r.entity.PackageAllocationStrategy))?.map(r => r.entity.PackageAllocationStrategy); if ($utils.isDefined(PackageAllocationStrategy)) { $grid.headers.PackageAllocationStrategy.hidden = false } else { $grid.headers.PackageAllocationStrategy.hidden = true }
      let DaysToFirstTasteTest = $grid.rows.filter(r => $utils.isDefined(r.entity.DaysToFirstTasteTest))?.map(r => r.entity.DaysToFirstTasteTest); if ($utils.isDefined(DaysToFirstTasteTest)) { $grid.headers.DaysToFirstTasteTest.hidden = false } else { $grid.headers.DaysToFirstTasteTest.hidden = true }
      let TasteTestCycleDays = $grid.rows.filter(r => $utils.isDefined(r.entity.TasteTestCycleDays))?.map(r => r.entity.TasteTestCycleDays); if ($utils.isDefined(TasteTestCycleDays)) { $grid.headers.TasteTestCycleDays.hidden = false } else { $grid.headers.TasteTestCycleDays.hidden = true }
      let ReallocationExpirationWindow = $grid.rows.filter(r => $utils.isDefined(r.entity.ReallocationExpirationWindow))?.map(r => r.entity.ReallocationExpirationWindow); if ($utils.isDefined(ReallocationExpirationWindow)) { $grid.headers.ReallocationExpirationWindow.hidden = false } else { $grid.headers.ReallocationExpirationWindow.hidden = true }
      let PrimaryPickLocationsPerWarehouse = $grid.rows.filter(r => $utils.isDefined(r.entity.PrimaryPickLocationsPerWarehouse))?.map(r => r.entity.PrimaryPickLocationsPerWarehouse); if ($utils.isDefined(PrimaryPickLocationsPerWarehouse)) { $grid.headers.PrimaryPickLocationsPerWarehouse.hidden = false } else { $grid.headers.PrimaryPickLocationsPerWarehouse.hidden = true }
      let ReceivingOverageThreshold = $grid.rows.filter(r => $utils.isDefined(r.entity.ReceivingOverageThreshold))?.map(r => r.entity.ReceivingOverageThreshold); if ($utils.isDefined(ReceivingOverageThreshold)) { $grid.headers.ReceivingOverageThreshold.hidden = false } else { $grid.headers.ReceivingOverageThreshold.hidden = true }
      let StandardUnitsPerHour = $grid.rows.filter(r => $utils.isDefined(r.entity.StandardUnitsPerHour))?.map(r => r.entity.StandardUnitsPerHour); if ($utils.isDefined(StandardUnitsPerHour)) { $grid.headers.StandardUnitsPerHour.hidden = false } else { $grid.headers.StandardUnitsPerHour.hidden = true }
      let AmbientTimeInHours = $grid.rows.filter(r => $utils.isDefined(r.entity.AmbientTimeInHours))?.map(r => r.entity.AmbientTimeInHours); if ($utils.isDefined(AmbientTimeInHours)) { $grid.headers.AmbientTimeInHours.hidden = false } else { $grid.headers.AmbientTimeInHours.hidden = true }
      let CycleCountTolerance = $grid.rows.filter(r => $utils.isDefined(r.entity.CycleCountTolerance))?.map(r => r.entity.CycleCountTolerance); if ($utils.isDefined(CycleCountTolerance)) { $grid.headers.CycleCountTolerance.hidden = false } else { $grid.headers.CycleCountTolerance.hidden = true }
      let StorageCategoryRule = $grid.rows.filter(r => $utils.isDefined(r.entity.StorageCategoryRule))?.map(r => r.entity.StorageCategoryRule); if ($utils.isDefined(StorageCategoryRule)) { $grid.headers.StorageCategoryRule.hidden = false } else { $grid.headers.StorageCategoryRule.hidden = true }
      let Uom = $grid.rows.filter(r => $utils.isDefined(r.entity.Uom))?.map(r => r.entity.Uom); if ($utils.isDefined(Uom)) { $grid.headers.Uom.hidden = false } else { $grid.headers.Uom.hidden = true }
      let SubUom = $grid.rows.filter(r => $utils.isDefined(r.entity.SubUom))?.map(r => r.entity.SubUom); if ($utils.isDefined(SubUom)) { $grid.headers.SubUom.hidden = false } else { $grid.headers.SubUom.hidden = true }
      let SubUomQuantity = $grid.rows.filter(r => $utils.isDefined(r.entity.SubUomQuantity))?.map(r => r.entity.SubUomQuantity); if ($utils.isDefined(SubUomQuantity)) { $grid.headers.SubUomQuantity.hidden = false } else { $grid.headers.SubUomQuantity.hidden = true }
      let DynamicUom = $grid.rows.filter(r => $utils.isDefined(r.entity.DynamicUom))?.map(r => r.entity.DynamicUom); if ($utils.isDefined(DynamicUom)) { $grid.headers.DynamicUom.hidden = false } else { $grid.headers.DynamicUom.hidden = true }
      let UomUpc = $grid.rows.filter(r => $utils.isDefined(r.entity.UomUpc))?.map(r => r.entity.UomUpc); if ($utils.isDefined(UomUpc)) { $grid.headers.UomUpc.hidden = false } else { $grid.headers.UomUpc.hidden = true }
      let UomAllowSale_YN = $grid.rows.filter(r => $utils.isDefined(r.entity.UomAllowSale_YN))?.map(r => r.entity.UomAllowSale_YN); if ($utils.isDefined(UomAllowSale_YN)) { $grid.headers.UomAllowSale_YN.hidden = false } else { $grid.headers.UomAllowSale_YN.hidden = true }
      let UomAllowPurchase_YN = $grid.rows.filter(r => $utils.isDefined(r.entity.UomAllowPurchase_YN))?.map(r => r.entity.UomAllowPurchase_YN); if ($utils.isDefined(UomAllowPurchase_YN)) { $grid.headers.UomAllowPurchase_YN.hidden = false } else { $grid.headers.UomAllowPurchase_YN.hidden = true }
      let UomReporting_YN = $grid.rows.filter(r => $utils.isDefined(r.entity.UomReporting_YN))?.map(r => r.entity.UomReporting_YN); if ($utils.isDefined(UomReporting_YN)) { $grid.headers.UomReporting_YN.hidden = false } else { $grid.headers.UomReporting_YN.hidden = true }
      let UomNonDefault_YN = $grid.rows.filter(r => $utils.isDefined(r.entity.UomNonDefault_YN))?.map(r => r.entity.UomNonDefault_YN); if ($utils.isDefined(UomNonDefault_YN)) { $grid.headers.UomNonDefault_YN.hidden = false } else { $grid.headers.UomNonDefault_YN.hidden = true }
      let UomPalletTie = $grid.rows.filter(r => $utils.isDefined(r.entity.UomPalletTie))?.map(r => r.entity.UomPalletTie); if ($utils.isDefined(UomPalletTie)) { $grid.headers.UomPalletTie.hidden = false } else { $grid.headers.UomPalletTie.hidden = true }
      let UomPalletHigh = $grid.rows.filter(r => $utils.isDefined(r.entity.UomPalletHigh))?.map(r => r.entity.UomPalletHigh); if ($utils.isDefined(UomPalletHigh)) { $grid.headers.UomPalletHigh.hidden = false } else { $grid.headers.UomPalletHigh.hidden = true }
      let UomStandardPrice = $grid.rows.filter(r => $utils.isDefined(r.entity.UomStandardPrice))?.map(r => r.entity.UomStandardPrice); if ($utils.isDefined(UomStandardPrice)) { $grid.headers.UomStandardPrice.hidden = false } else { $grid.headers.UomStandardPrice.hidden = true }
      let UomStandardCost = $grid.rows.filter(r => $utils.isDefined(r.entity.UomStandardCost))?.map(r => r.entity.UomStandardCost); if ($utils.isDefined(UomStandardCost)) { $grid.headers.UomStandardCost.hidden = false } else { $grid.headers.UomStandardCost.hidden = true }
      let UomWeight = $grid.rows.filter(r => $utils.isDefined(r.entity.UomWeight))?.map(r => r.entity.UomWeight); if ($utils.isDefined(UomWeight)) { $grid.headers.UomWeight.hidden = false } else { $grid.headers.UomWeight.hidden = true }
      let UomShippingWeight = $grid.rows.filter(r => $utils.isDefined(r.entity.UomShippingWeight))?.map(r => r.entity.UomShippingWeight); if ($utils.isDefined(UomShippingWeight)) { $grid.headers.UomShippingWeight.hidden = false } else { $grid.headers.UomShippingWeight.hidden = true }
      let UomLength = $grid.rows.filter(r => $utils.isDefined(r.entity.UomLength))?.map(r => r.entity.UomLength); if ($utils.isDefined(UomLength)) { $grid.headers.UomLength.hidden = false } else { $grid.headers.UomLength.hidden = true }
      let UomWidth = $grid.rows.filter(r => $utils.isDefined(r.entity.UomWidth))?.map(r => r.entity.UomWidth); if ($utils.isDefined(UomWidth)) { $grid.headers.UomWidth.hidden = false } else { $grid.headers.UomWidth.hidden = true }
      let UomHeight = $grid.rows.filter(r => $utils.isDefined(r.entity.UomHeight))?.map(r => r.entity.UomHeight); if ($utils.isDefined(UomHeight)) { $grid.headers.UomHeight.hidden = false } else { $grid.headers.UomHeight.hidden = true }
      let UomVolume = $grid.rows.filter(r => $utils.isDefined(r.entity.UomVolume))?.map(r => r.entity.UomVolume); if ($utils.isDefined(UomVolume)) { $grid.headers.UomVolume.hidden = false } else { $grid.headers.UomVolume.hidden = true }
      let UomWeightUnit = $grid.rows.filter(r => $utils.isDefined(r.entity.UomWeightUnit))?.map(r => r.entity.UomWeightUnit); if ($utils.isDefined(UomWeightUnit)) { $grid.headers.UomWeightUnit.hidden = false } else { $grid.headers.UomWeightUnit.hidden = true }
      let UomDimensionUnit = $grid.rows.filter(r => $utils.isDefined(r.entity.UomDimensionUnit))?.map(r => r.entity.UomDimensionUnit); if ($utils.isDefined(UomDimensionUnit)) { $grid.headers.UomDimensionUnit.hidden = false } else { $grid.headers.UomDimensionUnit.hidden = true }
      let UomVolumeUnit = $grid.rows.filter(r => $utils.isDefined(r.entity.UomVolumeUnit))?.map(r => r.entity.UomVolumeUnit); if ($utils.isDefined(UomVolumeUnit)) { $grid.headers.UomVolumeUnit.hidden = false } else { $grid.headers.UomVolumeUnit.hidden = true }
      let ManufacturingCrewComplement = $grid.rows.filter(r => $utils.isDefined(r.entity.ManufacturingCrewComplement))?.map(r => r.entity.ManufacturingCrewComplement); if ($utils.isDefined(ManufacturingCrewComplement)) { $grid.headers.ManufacturingCrewComplement.hidden = false } else { $grid.headers.ManufacturingCrewComplement.hidden = true }
      let LpMixingRestriction = $grid.rows.filter(r => $utils.isDefined(r.entity.LpMixingRestriction))?.map(r => r.entity.LpMixingRestriction); if ($utils.isDefined(LpMixingRestriction)) { $grid.headers.LpMixingRestriction.hidden = false } else { $grid.headers.LpMixingRestriction.hidden = true }
      let AutoPopulateLot = $grid.rows.filter(r => $utils.isDefined(r.entity.AutoPopulateLot))?.map(r => r.entity.AutoPopulateLot); if ($utils.isDefined(AutoPopulateLot)) { $grid.headers.AutoPopulateLot.hidden = false } else { $grid.headers.AutoPopulateLot.hidden = true }
      let AutoPopulateVendorLot = $grid.rows.filter(r => $utils.isDefined(r.entity.AutoPopulateVendorLot))?.map(r => r.entity.AutoPopulateVendorLot); if ($utils.isDefined(AutoPopulateVendorLot)) { $grid.headers.AutoPopulateVendorLot.hidden = false } else { $grid.headers.AutoPopulateVendorLot.hidden = true }
      let MaterialTagList = $grid.rows.filter(r => $utils.isDefined(r.entity.MaterialTagList))?.map(r => r.entity.MaterialTagList); if ($utils.isDefined(MaterialTagList)) { $grid.headers.MaterialTagList.hidden = false } else { $grid.headers.MaterialTagList.hidden = true }
      let UDF01Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF01Name))?.map(r => r.entity.UDF01Name); if ($utils.isDefined(UDF01Name)) { $grid.headers.UDF01Name.hidden = false } else { $grid.headers.UDF01Name.hidden = true }
      let UDF01Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF01Value))?.map(r => r.entity.UDF01Value); if ($utils.isDefined(UDF01Value)) { $grid.headers.UDF01Value.hidden = false } else { $grid.headers.UDF01Value.hidden = true }
      let UDF02Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF02Name))?.map(r => r.entity.UDF02Name); if ($utils.isDefined(UDF02Name)) { $grid.headers.UDF02Name.hidden = false } else { $grid.headers.UDF02Name.hidden = true }
      let UDF02Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF02Value))?.map(r => r.entity.UDF02Value); if ($utils.isDefined(UDF02Value)) { $grid.headers.UDF02Value.hidden = false } else { $grid.headers.UDF02Value.hidden = true }
      let UDF03Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF03Name))?.map(r => r.entity.UDF03Name); if ($utils.isDefined(UDF03Name)) { $grid.headers.UDF03Name.hidden = false } else { $grid.headers.UDF03Name.hidden = true }
      let UDF03Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF03Value))?.map(r => r.entity.UDF03Value); if ($utils.isDefined(UDF03Value)) { $grid.headers.UDF03Value.hidden = false } else { $grid.headers.UDF03Value.hidden = true }
      let UDF04Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF04Name))?.map(r => r.entity.UDF04Name); if ($utils.isDefined(UDF04Name)) { $grid.headers.UDF04Name.hidden = false } else { $grid.headers.UDF04Name.hidden = true }
      let UDF04Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF04Value))?.map(r => r.entity.UDF04Value); if ($utils.isDefined(UDF04Value)) { $grid.headers.UDF04Value.hidden = false } else { $grid.headers.UDF04Value.hidden = true }
      let UDF05Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF05Name))?.map(r => r.entity.UDF05Name); if ($utils.isDefined(UDF05Name)) { $grid.headers.UDF05Name.hidden = false } else { $grid.headers.UDF05Name.hidden = true }
      let UDF05Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF05Value))?.map(r => r.entity.UDF05Value); if ($utils.isDefined(UDF05Value)) { $grid.headers.UDF05Value.hidden = false } else { $grid.headers.UDF05Value.hidden = true }
      let UDF06Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF06Name))?.map(r => r.entity.UDF06Name); if ($utils.isDefined(UDF06Name)) { $grid.headers.UDF06Name.hidden = false } else { $grid.headers.UDF06Name.hidden = true }
      let UDF06Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF06Value))?.map(r => r.entity.UDF06Value); if ($utils.isDefined(UDF06Value)) { $grid.headers.UDF06Value.hidden = false } else { $grid.headers.UDF06Value.hidden = true }
      let UDF07Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF07Name))?.map(r => r.entity.UDF07Name); if ($utils.isDefined(UDF07Name)) { $grid.headers.UDF07Name.hidden = false } else { $grid.headers.UDF07Name.hidden = true }
      let UDF07Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF07Value))?.map(r => r.entity.UDF07Value); if ($utils.isDefined(UDF07Value)) { $grid.headers.UDF07Value.hidden = false } else { $grid.headers.UDF07Value.hidden = true }
      let UDF08Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF08Name))?.map(r => r.entity.UDF08Name); if ($utils.isDefined(UDF08Name)) { $grid.headers.UDF08Name.hidden = false } else { $grid.headers.UDF08Name.hidden = true }
      let UDF08Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF08Value))?.map(r => r.entity.UDF08Value); if ($utils.isDefined(UDF08Value)) { $grid.headers.UDF08Value.hidden = false } else { $grid.headers.UDF08Value.hidden = true }
      let UDF09Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF09Name))?.map(r => r.entity.UDF09Name); if ($utils.isDefined(UDF09Name)) { $grid.headers.UDF09Name.hidden = false } else { $grid.headers.UDF09Name.hidden = true }
      let UDF09Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF09Value))?.map(r => r.entity.UDF09Value); if ($utils.isDefined(UDF09Value)) { $grid.headers.UDF09Value.hidden = false } else { $grid.headers.UDF09Value.hidden = true }
      let UDF10Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF10Name))?.map(r => r.entity.UDF10Name); if ($utils.isDefined(UDF10Name)) { $grid.headers.UDF10Name.hidden = false } else { $grid.headers.UDF10Name.hidden = true }
      let UDF10Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF10Value))?.map(r => r.entity.UDF10Value); if ($utils.isDefined(UDF10Value)) { $grid.headers.UDF10Value.hidden = false } else { $grid.headers.UDF10Value.hidden = true }
      let UDF11Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF11Name))?.map(r => r.entity.UDF11Name); if ($utils.isDefined(UDF11Name)) { $grid.headers.UDF11Name.hidden = false } else { $grid.headers.UDF11Name.hidden = true }
      let UDF11Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF11Value))?.map(r => r.entity.UDF11Value); if ($utils.isDefined(UDF11Value)) { $grid.headers.UDF11Value.hidden = false } else { $grid.headers.UDF11Value.hidden = true }
      let UDF12Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF12Name))?.map(r => r.entity.UDF12Name); if ($utils.isDefined(UDF12Name)) { $grid.headers.UDF12Name.hidden = false } else { $grid.headers.UDF12Name.hidden = true }
      let UDF12Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF12Value))?.map(r => r.entity.UDF12Value); if ($utils.isDefined(UDF12Value)) { $grid.headers.UDF12Value.hidden = false } else { $grid.headers.UDF12Value.hidden = true }
      let UDF13Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF13Name))?.map(r => r.entity.UDF13Name); if ($utils.isDefined(UDF13Name)) { $grid.headers.UDF13Name.hidden = false } else { $grid.headers.UDF13Name.hidden = true }
      let UDF13Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF13Value))?.map(r => r.entity.UDF13Value); if ($utils.isDefined(UDF13Value)) { $grid.headers.UDF13Value.hidden = false } else { $grid.headers.UDF13Value.hidden = true }
      let UDF14Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF14Name))?.map(r => r.entity.UDF14Name); if ($utils.isDefined(UDF14Name)) { $grid.headers.UDF14Name.hidden = false } else { $grid.headers.UDF14Name.hidden = true }
      let UDF14Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF14Value))?.map(r => r.entity.UDF14Value); if ($utils.isDefined(UDF14Value)) { $grid.headers.UDF14Value.hidden = false } else { $grid.headers.UDF14Value.hidden = true }
      let UDF15Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF15Name))?.map(r => r.entity.UDF15Name); if ($utils.isDefined(UDF15Name)) { $grid.headers.UDF15Name.hidden = false } else { $grid.headers.UDF15Name.hidden = true }
      let UDF15Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF15Value))?.map(r => r.entity.UDF15Value); if ($utils.isDefined(UDF15Value)) { $grid.headers.UDF15Value.hidden = false } else { $grid.headers.UDF15Value.hidden = true }
      let UDF16Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF16Name))?.map(r => r.entity.UDF16Name); if ($utils.isDefined(UDF16Name)) { $grid.headers.UDF16Name.hidden = false } else { $grid.headers.UDF16Name.hidden = true }
      let UDF16Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF16Value))?.map(r => r.entity.UDF16Value); if ($utils.isDefined(UDF16Value)) { $grid.headers.UDF16Value.hidden = false } else { $grid.headers.UDF16Value.hidden = true }
      let UDF17Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF17Name))?.map(r => r.entity.UDF17Name); if ($utils.isDefined(UDF17Name)) { $grid.headers.UDF17Name.hidden = false } else { $grid.headers.UDF17Name.hidden = true }
      let UDF17Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF17Value))?.map(r => r.entity.UDF17Value); if ($utils.isDefined(UDF17Value)) { $grid.headers.UDF17Value.hidden = false } else { $grid.headers.UDF17Value.hidden = true }
      let UDF18Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF18Name))?.map(r => r.entity.UDF18Name); if ($utils.isDefined(UDF18Name)) { $grid.headers.UDF18Name.hidden = false } else { $grid.headers.UDF18Name.hidden = true }
      let UDF18Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF18Value))?.map(r => r.entity.UDF18Value); if ($utils.isDefined(UDF18Value)) { $grid.headers.UDF18Value.hidden = false } else { $grid.headers.UDF18Value.hidden = true }
      let UDF19Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF19Name))?.map(r => r.entity.UDF19Name); if ($utils.isDefined(UDF19Name)) { $grid.headers.UDF19Name.hidden = false } else { $grid.headers.UDF19Name.hidden = true }
      let UDF19Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF19Value))?.map(r => r.entity.UDF19Value); if ($utils.isDefined(UDF19Value)) { $grid.headers.UDF19Value.hidden = false } else { $grid.headers.UDF19Value.hidden = true }
      let UDF20Name = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF20Name))?.map(r => r.entity.UDF20Name); if ($utils.isDefined(UDF20Name)) { $grid.headers.UDF20Name.hidden = false } else { $grid.headers.UDF20Name.hidden = true }
      let UDF20Value = $grid.rows.filter(r => $utils.isDefined(r.entity.UDF20Value))?.map(r => r.entity.UDF20Value); if ($utils.isDefined(UDF20Value)) { $grid.headers.UDF20Value.hidden = false } else { $grid.headers.UDF20Value.hidden = true }
  
  }
  
  
  let errors = (await $flows.ExcelMaterialImport.material_import_staging({
      action: "Count",
      import_status: "Error"
  })).count;
  
  if ($utils.isDefined(errors)) {
      $grid.topToolbar.errors.hidden = false;
      $grid.topToolbar.errors.control.label = `Error ${errors}`;
  } else {
      $grid.topToolbar.errors.hidden = true;
  }
  
  let ready = (await $flows.ExcelMaterialImport.material_import_staging({
      action: "Count",
      import_status: "Ready"
  })).count;
  
  if ($utils.isDefined(ready)) {
      $grid.topToolbar.ready.hidden = false;
      $grid.topToolbar.ready.control.label = `Ready ${ready}`;
  } else {
      $grid.topToolbar.ready.hidden = true;
  }
  
  let submitted = (await $flows.ExcelMaterialImport.material_import_staging({
      action: "Count",
      import_status: "Submitted"
  })).count;
  
  if ($utils.isDefined(submitted)) {
      $grid.topToolbar.submitted.hidden = false;
      $grid.topToolbar.submitted.control.label = `Submitted ${submitted}`;
  } else {
      $grid.topToolbar.submitted.hidden = true;
  }
  }
  on_confirm_clicked(event = null) {
    return this.on_confirm_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_confirm_clickedInternal(
    $grid: ExcelMaterialImport_excel_material_import_staging_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/14/2024
  
  await $flows.ExcelMaterialImport.material_import_staging_confirm({});
  
  $grid.refresh();
  }
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $grid: ExcelMaterialImport_excel_material_import_staging_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/20/2024
  
  const selected_rows = $grid.selectedRows;
  let errors: { reference: string, id: string, errorMessages: string[] }[] = [];
  let deleted_records: string[] = [];
  
  if (selected_rows.length === 0) {
      $shell.ExcelMaterialImport.openErrorDialog('Delete error', 'No records were selected.');
      return;
  } else {
  
      const confirm_purge = (await $shell.ExcelMaterialImport.openConfirmationDialog(`Confirm delete`, `Do you want to delete ${selected_rows.length} records?`, `Delete`, `Cancel`));
  
      if (confirm_purge) {
  
          for (const row of selected_rows) {
  
              let current_error: string;
              let success = false;
              current_error = null;
  
              try {
  
                  let entity = row.entity
  
                  await message_delete({
                      Id: entity.Id
                  });
  
                  success = true;
  
              } catch (error) {
  
                  let target_error = error;
  
                  if (typeof target_error === "string") {
                      target_error = { message: target_error };
                  } else {
                      while ($utils.isDefined(target_error.error)) {
                          target_error = target_error.error;
                      };
                  };
  
                  if (!$utils.isDefined(target_error.message)) {
                      target_error = { message: `Uncaught exception ${JSON.stringify(target_error)}` };
                  };
  
                  current_error = target_error.message;
              };
  
              if (success) {
                  deleted_records.push(row.entity.Id.toString())
              } else {
                  errors.push({
                      reference: row.entity.LookupCode, id: row.entity.Id, errorMessages: [current_error]
                  });
              };
          };
  
          if ($utils.isDefined(errors)) {
              await $shell.ExcelMaterialImport.openErrorDialog(
                  `Delete record${selected_rows.length > 1 ? 's' : ''}`,
                  deleted_records.length > 0 ? `Record${selected_rows.length > 1 ? 's' : ''} ${(await $flows.Utilities.grammar_format_string_array_flow({ values: deleted_records })).formattedValue} successfully deleted.` : `No records were deleted.`,
                  null,
                  `Errors deleting record${selected_rows.length > 1 ? 's' : ''}`,
                  errors.map(error => ({ detail: error.errorMessages[0], message: `Id: ${error.id} Reference: ${error.reference}` })))
          };
      };
  };
  
  $grid.refresh();
  
  async function message_delete(input: $types.ExcelMaterialImport.MaterialImportRecord) {
      await $flows.ExcelMaterialImport.material_import_staging({ action: "Delete", payload: [input] });
  };
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: ExcelMaterialImport_excel_material_import_staging_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_staging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/20/2024
  
  const selectedRowsCount = $grid.selectedRows.length;
  
  $grid.topToolbar.delete_row.control.readOnly = (selectedRowsCount > 0 ? false : true);
  
  if (selectedRowsCount === 1) {
      $grid.topToolbar.delete_row.control.label = "Delete row";
  } else if (selectedRowsCount > 1) {
      $grid.topToolbar.delete_row.control.label = "Delete rows";
  } else {
      $grid.topToolbar.delete_row.control.label = "Delete row";
  }
  }
  //#endregion private flows

  async $importExcel(fileInput: HTMLInputElement) {
    if(fileInput.files?.length !== 1) {
      throw new Error('Cannot import multiple files');
    }
    const file = fileInput.files[0];
    if(file.size > 15 * 1000 * 1000) {
      throw new Error('Cannot import a file with size greater than 15MB');
    }
    const reader: FileReader = new FileReader();
    reader.onload = async (e: ProgressEvent<FileReader>) => {
      const ab: ArrayBuffer = e.target?.result as ArrayBuffer;
      const wb: WorkBook = readExcelFile(ab);
      await this.on_excel_import(wb);
    };
    reader.readAsArrayBuffer(file);
    fileInput.value = '';
  }

  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_excel_export(wb);

    writeExcelFile(wb, 'ExcelMaterialImport_excel_material_import_staging_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
